import * as React from 'react'
import LAYOUT_FRAMES from './showcaseLayout.json'

const m = React
const t = {
  Fragment: React.Fragment,
  jsx(type, props, keyArg) {
    if (props == null) return React.createElement(type)
    const { children, key: keyProp, ...rest } = props
    const key = keyArg ?? keyProp
    if (key !== undefined && key !== null) rest.key = key
    if (Array.isArray(children)) return React.createElement(type, rest, ...children)
    if (children !== undefined && children !== false && children !== null) {
      return React.createElement(type, rest, children)
    }
    return React.createElement(type, rest)
  },
  jsxs(type, props, keyArg) {
    return t.jsx(type, props, keyArg)
  },
}

const ACCOUNT_COLORS = {
  Pink: '#FF6B9D',
  Orange: '#FF9F2E',
  Yellow: '#FBBF24',
  Green: '#1BD289',
  Blue: '#6C7CFF',
  Purple: '#A78BFA',
}
const X = (label) => ACCOUNT_COLORS[label]

export const I = { w: 800, h: 450 },
  dt = "var(--showcase-sheet)",
  vt = "var(--showcase-panel)",
  o = (e) => `rgba(var(--showcase-ink-rgb), ${e})`,
  L = (e) => `color-mix(in oklch, var(--showcase-accent) ${Math.round(e * 100)}%, transparent)`,
  z = "cubic-bezier(0.23, 1, 0.32, 1)",
  be = { fontFamily: "var(--font-mono)", fontFeatureSettings: "'case' 1" },
  c = {
    position: "absolute",
    fontFamily: "var(--font-mono)",
    fontSize: 8.5,
    lineHeight: 1,
    letterSpacing: "0.04em",
    color: o(0.42),
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },
  Z = {
    position: "absolute",
    fontFamily: "var(--font-mono)",
    fontSize: 13,
    lineHeight: 1,
    letterSpacing: "0.04em",
    color: o(0.62),
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
  },
  qt = {
    position: "absolute",
    fontFamily: "var(--font-mono)",
    fontSize: 8,
    lineHeight: 1,
    letterSpacing: "0.04em",
    color: o(0.34),
    fontVariantNumeric: "tabular-nums",
  },
  ft = ({ children: e }) =>
    t.jsxs("div", {
      "data-wire-sheet": !0,
      className: "absolute inset-0 overflow-hidden",
      style: { background: dt },
      children: [
        t.jsx("div", {
          className: "absolute inset-0",
          style: {
            backgroundImage: `linear-gradient(${o(0.025)} 1px, transparent 1px), linear-gradient(90deg, ${o(0.025)} 1px, transparent 1px)`,
            backgroundSize: "20px 20px",
            backgroundPosition: "15.5px 12.5px",
            maskImage: "radial-gradient(ellipse 68% 74% at 50% 46%, black 34%, transparent 82%)",
            WebkitMaskImage: "radial-gradient(ellipse 68% 74% at 50% 46%, black 34%, transparent 82%)",
          },
        }),
        t.jsx("div", {
          className: "absolute inset-0",
          style: { background: `radial-gradient(58% 42% at 50% 0%, ${o(0.05)}, transparent 70%)` },
        }),
        e,
      ],
    }),
  B = (e, s, n, a, i = 0.11, l = 4) => ({
    position: "absolute",
    left: e,
    top: s,
    width: n,
    height: a,
    borderRadius: l,
    border: `0.5px solid ${o(i)}`,
  }),
  v = (e, s, n, a = 0.16, i = 3) => ({
    position: "absolute",
    left: e,
    top: s,
    width: n,
    height: i,
    borderRadius: i / 2,
    background: o(a),
  }),
  lt = (e, s, n = 8, a = 0.26) => ({
    position: "absolute",
    left: e,
    top: s,
    width: n,
    height: n,
    borderRadius: "50%",
    background: o(a),
  }),
  Zt = (e, s, n) => {
    const a = Math.min(...e),
      l = Math.max(...e) - a || 1;
    return e
      .map(
        (h, r) =>
          `${r === 0 ? "M" : "L"}${((r / (e.length - 1)) * s).toFixed(1)} ${(n - ((h - a) / l) * n).toFixed(1)}`,
      )
      .join(" ");
  },
  ye = ({ x: e, y: s, w: n, h: a, pts: i, a: l = 0.22, color: h }) =>
    t.jsx("svg", {
      style: { position: "absolute", left: e, top: s, width: n, height: a },
      viewBox: `0 0 ${n} ${a}`,
      fill: "none",
      children: t.jsx("path", {
        d: Zt(i, n, a - 4),
        stroke: h ?? o(l),
        strokeWidth: 1,
        fill: "none",
        strokeLinecap: "round",
      }),
    }),
  ge = "M4 0.4 L5.1 2.7 L7.7 3 L5.8 4.8 L6.3 7.4 L4 6.1 L1.7 7.4 L2.2 4.8 L0.3 3 L2.9 2.7 Z",
  $t = ({ x: e, y: s, a: n = 0.3 }) =>
    t.jsx("svg", {
      style: { position: "absolute", left: e, top: s, width: 8, height: 8 },
      viewBox: "0 0 8 8",
      fill: "none",
      children: t.jsx("path", {
        d: ge,
        stroke: o(n),
        strokeWidth: 0.9,
        strokeLinejoin: "round",
        fill: "none",
      }),
    }),
  Mt = ({ x1: e, x2: s, y: n, num: a }) =>
    t.jsxs(t.Fragment, {
      children: [
        t.jsx("span", {
          style: { position: "absolute", left: e, top: n, width: s - e, height: 1, background: o(0.14) },
        }),
        t.jsx("span", {
          style: { position: "absolute", left: e, top: n - 3, width: 1, height: 7, background: o(0.22) },
        }),
        t.jsx("span", {
          style: { position: "absolute", left: s, top: n - 3, width: 1, height: 7, background: o(0.22) },
        }),
        a &&
          t.jsx("span", {
            style: {
              ...qt,
              left: (e + s) / 2,
              top: n - 3.5,
              transform: "translateX(-50%)",
              background: dt,
              padding: "0 5px",
            },
            children: a,
          }),
      ],
    }),
  Wt = ({ y1: e, y2: s, x: n, num: a }) =>
    t.jsxs(t.Fragment, {
      children: [
        t.jsx("span", {
          style: { position: "absolute", left: n, top: e, width: 1, height: s - e, background: o(0.14) },
        }),
        t.jsx("span", {
          style: { position: "absolute", left: n - 3, top: e, width: 7, height: 1, background: o(0.22) },
        }),
        t.jsx("span", {
          style: { position: "absolute", left: n - 3, top: s, width: 7, height: 1, background: o(0.22) },
        }),
        a &&
          t.jsx("span", {
            style: {
              ...qt,
              left: n,
              top: (e + s) / 2,
              transform: "translate(-50%, -50%) rotate(-90deg)",
              background: dt,
              padding: "0 5px",
            },
            children: a,
          }),
      ],
    }),
  At = ({ pts: e, label: s, labelAt: n }) => {
    const a = e.map((l, h) => `${h === 0 ? "M" : "L"}${l[0]} ${l[1]}`).join(" "),
      i = e[e.length - 1];
    return t.jsxs(t.Fragment, {
      children: [
        t.jsxs("svg", {
          className: "absolute inset-0",
          width: I.w,
          height: I.h,
          fill: "none",
          style: { pointerEvents: "none" },
          children: [
            t.jsx("path", { d: a, stroke: o(0.28), strokeWidth: 1 }),
            t.jsx("circle", { cx: i[0], cy: i[1], r: 2.5, stroke: o(0.4), strokeWidth: 1, fill: "none" }),
          ],
        }),
        s &&
          t.jsx("span", { style: { ...c, left: n?.[0] ?? i[0] + 8, top: n?.[1] ?? i[1] - 4 }, children: s }),
      ],
    });
  },
  zt = ({ park: e, move: s, press: n, dip: a, dur: i }) =>
    t.jsxs("span", {
      style: {
        position: "absolute",
        left: e[0],
        top: e[1],
        zIndex: 5,
        animation: `${s} ${i}s ${z} infinite`,
        filter: "drop-shadow(0 2px 6px rgba(0, 0, 0, 0.55))",
      },
      children: [
        t.jsx("span", {
          style: {
            position: "absolute",
            left: -6,
            top: -6,
            width: 12,
            height: 12,
            borderRadius: "50%",
            border: `1px solid ${L(0.8)}`,
            opacity: 0,
            animation: `${n} ${i}s linear infinite`,
          },
        }),
        t.jsx("svg", {
          width: 18,
          height: 18,
          viewBox: "0 0 18 18",
          fill: "none",
          style: {
            display: "block",
            marginLeft: -2,
            marginTop: -2,
            transformOrigin: "2px 2px",
            animation: a ? `${a} ${i}s ${z} infinite` : void 0,
          },
          children: t.jsx("path", {
            d: "M15.154,6.253L3.731,2.079h0c-.477-.175-.994-.058-1.353,.3-.357,.358-.473,.876-.298,1.352L6.254,15.154c.188,.517,.66,.846,1.208,.846,.009,0,.019,0,.027,0,.559-.011,1.03-.362,1.2-.895l1.556-4.86,4.859-1.555c.532-.17,.884-.642,.896-1.201,.011-.559-.321-1.044-.846-1.236Z",
            fill: o(0.95),
          }),
        }),
      ],
    }),
  Ft = ({ x: e, y: s, w: n, h: a, r: i = 11, anim: l, dur: h = 6 }) =>
    t.jsx("span", {
      style: {
        position: "absolute",
        left: e,
        top: s,
        width: n,
        height: a,
        borderRadius: i,
        border: `1px solid ${L(0.45)}`,
        boxShadow: `0 0 16px ${L(0.14)}`,
        animation: l,
      },
      children: t.jsx("span", {
        style: {
          position: "absolute",
          inset: -1,
          borderRadius: i,
          padding: 1.5,
          overflow: "hidden",
          WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "xor",
          mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          maskComposite: "exclude",
        },
        children: t.jsx("span", {
          style: {
            position: "absolute",
            left: "50%",
            top: "50%",
            width: "340%",
            aspectRatio: "1 / 1",
            transform: "translate(-50%, -50%)",
            background: `conic-gradient(from 0deg, transparent 0deg 286deg, ${L(0.95)} 326deg, transparent 354deg)`,
            animation: `lscBeamSpin ${h}s linear infinite`,
          },
        }),
      }),
    }),
  we = [
    [90.2, 19.5],
    [120.2, 27.9],
    [158.7, 41],
    [210.2, 25],
    [245.7, 37.1],
    [293.3, 30.1],
    [334, 25],
    [369.6, 24.2],
  ],
  me = [640.9, 657.6, 674.2, 690.8, 707.5, 724.1, 740.7],
  Jt = ({ active: e = 0, lit: s, gear: n }) =>
    t.jsxs(t.Fragment, {
      children: [
        t.jsx("div", {
          style: { position: "absolute", left: 40, top: 45.7, width: 720, height: 0.5, background: o(0.08) },
        }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: 45.3,
            top: 29.3,
            width: 4.9,
            height: 10,
            borderRadius: 1,
            background: o(0.6),
          },
        }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: 53.5,
            top: 30.6,
            width: 24.9,
            height: 7.4,
            borderRadius: 1,
            background: o(0.42),
          },
        }),
        t.jsx("span", {
          style: { position: "absolute", left: 82, top: 29.5, width: 0.5, height: 8.8, background: o(0.12) },
        }),
        we.map(([a, i], l) =>
          t.jsx(
            "span",
            {
              style: {
                position: "absolute",
                left: a,
                top: 31.4,
                width: i,
                height: 5.6,
                borderRadius: 1,
                background: o(l === e ? 0.4 : 0.13),
              },
            },
            a,
          ),
        ),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: 553.3,
            top: 27.3,
            width: 14,
            height: 14,
            borderRadius: 1.5,
            border: `0.5px solid ${o(0.11)}`,
          },
        }),
        t.jsx("div", {
          style: {
            position: "absolute",
            left: 570,
            top: 27.3,
            width: 68.3,
            height: 14,
            borderRadius: 1.5,
            border: `0.5px solid ${o(0.12)}`,
            background: o(0.02),
          },
        }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: 575,
            top: 32.4,
            width: 40,
            height: 3.8,
            borderRadius: 1,
            background: o(0.16),
          },
        }),
        me.map((a, i) =>
          t.jsx(
            "span",
            {
              style: {
                position: "absolute",
                left: a,
                top: 27.3,
                width: 14,
                height: 14,
                borderRadius: 1.5,
                border: `0.5px solid ${o(i === s ? 0.34 : 0.11)}`,
              },
            },
            a,
          ),
        ),
        n &&
          t.jsxs(t.Fragment, {
            children: [
              t.jsx("span", {
                style: {
                  position: "absolute",
                  left: 678.7,
                  top: 31.8,
                  width: 5,
                  height: 5,
                  borderRadius: "50%",
                  border: `0.5px solid ${o(0.55)}`,
                },
              }),
              t.jsx(Ft, { x: 672, y: 25.3, w: 18, h: 18, r: 2, dur: 7 }),
            ],
          }),
      ],
    }),
  Gt = "#/\\<>+=:%1030",
  je = ({ text: e, step: s = 40 }) => {
    const [n, a] = m.useState("");
    return (
      m.useEffect(() => {
        if (n === e) return;
        let i = 0;
        const l = setInterval(() => {
          if (((i += 0.6), i >= e.length)) {
            (a(e), clearInterval(l));
            return;
          }
          a(
            e
              .split("")
              .map((h, r) => (r < i || h === " " ? h : Gt[(r * 7 + Math.floor(i * 3)) % Gt.length]))
              .join(""),
          );
        }, s);
        return () => clearInterval(l);
      }, []),
      t.jsx(t.Fragment, { children: n || "┬á" })
    );
  },
  ke = (() => {
    const s = (d) => +(d * 0.5).toFixed(2),
      n = 40 + s(100),
      a = s(1240),
      i = n + s(28.16),
      l = a - s(56.32),
      h = 45.7;
    return { d: s, CX: i, CW: l, y: (d) => +(h + d * 0.5).toFixed(2) };
  })(),
  bt = [
    { name: "Main Account", type: "Main", color: X("Green"), usd: "$151,265.45", pct: "76.6" },
    { name: "Scalper", type: "Sub", color: X("Blue"), usd: "$15,530.20", pct: "7.9" },
    { name: "Swing", type: "Sub", color: X("Orange"), usd: "$10,160.55", pct: "5.1" },
    { name: "RWA Basket", type: "Sub", color: X("Purple"), usd: "$4,705.00", pct: "2.4" },
    { name: "Alpha Pool", type: "Sub", color: X("Yellow"), usd: "$15,750.00", pct: "8.0" },
  ],
  Se = [
    ["TOTAL EQUITY", "$197,411.20"],
    ["ACCOUNTS", "5"],
    ["MAIN ACCOUNT", "$151,265.45"],
    ["IN SUB-ACCOUNTS", "$46,145.75"],
  ],
  It = X("Pink"),
  ve = [X("Pink"), X("Orange"), X("Yellow"), X("Green"), X("Blue"), X("Purple")],
  tt = (e) => `${e} 6s ${z} infinite`,
  Ae = () => {
    const { d: e, CX: s, CW: n, y: a } = ke,
      i = (n - 3 * e(42.24)) / 4,
      l = a(362.6),
      h = e(74.9),
      r = e(14.08),
      d = e(31.68),
      b = s + r,
      p = (x) => l + x * e(85.46) + (h - d) / 2,
      g = { y: p(1) + d / 2 },
      u = { x: b + e(26), y: p(1) + d + e(10), w: e(157.4), h: e(32) };
    return t.jsxs(ft, {
      children: [
        t.jsx(Jt, { active: 6, lit: 6 }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: s,
            top: a(35.2),
            fontSize: e(44),
            lineHeight: `${e(45)}px`,
            fontWeight: 500,
            letterSpacing: "-0.02em",
            color: o(0.66),
          },
          children: "Sub-Accounts",
        }),
        t.jsx("div", {
          style: {
            position: "absolute",
            left: s + n - e(88),
            top: a(40),
            width: e(88),
            height: e(35.2),
            borderRadius: 3,
            background: o(0.86),
          },
        }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: s + n - e(66),
            top: a(48),
            width: e(44),
            height: e(7),
            borderRadius: 1,
            background: "rgba(6, 6, 12, 0.62)",
          },
        }),
        [0, 1].map((x) =>
          t.jsx(
            "span",
            {
              style: {
                position: "absolute",
                left: s,
                top: a(98 + x * 24),
                width: e(x ? 392 : 548),
                height: e(7),
                borderRadius: 1,
                background: o(0.13),
              },
            },
            x,
          ),
        ),
        Se.map(([x, y], O) =>
          t.jsxs(
            m.Fragment,
            {
              children: [
                t.jsx("span", {
                  style: { ...c, left: s + O * (i + e(42.24)), top: a(166.8), fontSize: 6.5, color: o(0.36) },
                  children: x,
                }),
                t.jsx("span", {
                  style: { ...Z, left: s + O * (i + e(42.24)), top: a(188), fontSize: 11, color: o(0.82) },
                  children: y,
                }),
              ],
            },
            x,
          ),
        ),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: s,
            top: a(234.7),
            fontSize: e(22),
            lineHeight: `${e(26)}px`,
            fontWeight: 500,
            color: o(0.55),
          },
          children: "Equity Allocation",
        }),
        t.jsx("span", {
          style: { ...Z, left: void 0, right: I.w - (s + n), top: a(242), fontSize: 6.5, color: o(0.32) },
          children: "$197,411.20 total",
        }),
        t.jsx("div", {
          style: {
            position: "absolute",
            left: s,
            top: a(271.3),
            width: n,
            height: e(10.56),
            borderRadius: e(10.56) / 2,
            overflow: "hidden",
            display: "flex",
            background: o(0.06),
          },
          children: bt.map((x, y) =>
            t.jsx(
              "span",
              {
                style: {
                  display: "block",
                  height: "100%",
                  width: `${x.pct}%`,
                  background: x.color,
                  animation: y === 1 ? tt("wsOld") : void 0,
                },
              },
              x.name,
            ),
          ),
        }),
        t.jsxs("div", {
          style: {
            position: "absolute",
            left: s,
            top: a(271.3),
            width: n,
            height: e(10.56),
            borderRadius: e(10.56) / 2,
            overflow: "hidden",
            display: "flex",
          },
          children: [
            t.jsx("span", {
              style: { display: "block", height: "100%", width: `${bt[0].pct}%`, background: "transparent" },
            }),
            t.jsx("span", {
              style: {
                display: "block",
                height: "100%",
                width: `${bt[1].pct}%`,
                background: It,
                opacity: 0,
                animation: tt("wsNew"),
              },
            }),
          ],
        }),
        t.jsx("div", {
          style: {
            position: "absolute",
            left: s,
            top: a(292.4),
            width: n,
            display: "flex",
            flexWrap: "wrap",
            columnGap: e(17.6),
            rowGap: e(7.04),
            alignItems: "center",
          },
          children: bt.map((x, y) =>
            t.jsxs(
              "span",
              {
                style: { display: "inline-flex", alignItems: "center", gap: e(7.04), position: "relative" },
                children: [
                  t.jsx("span", {
                    style: {
                      display: "block",
                      width: e(8.8),
                      height: e(8.8),
                      borderRadius: "50%",
                      background: x.color,
                      animation: y === 1 ? tt("wsOld") : void 0,
                    },
                  }),
                  y === 1 &&
                    t.jsx("span", {
                      style: {
                        position: "absolute",
                        left: 0,
                        top: "50%",
                        marginTop: -e(4.4),
                        width: e(8.8),
                        height: e(8.8),
                        borderRadius: "50%",
                        background: It,
                        opacity: 0,
                        animation: tt("wsNew"),
                      },
                    }),
                  t.jsx("span", { style: { fontSize: 6.5, color: o(0.4) }, children: x.name }),
                  t.jsx("span", {
                    style: {
                      fontFamily: "var(--font-mono)",
                      fontSize: 6.5,
                      color: o(0.62),
                      fontVariantNumeric: "tabular-nums",
                    },
                    children: x.usd,
                  }),
                  t.jsxs("span", {
                    style: {
                      fontFamily: "var(--font-mono)",
                      fontSize: 6.5,
                      color: o(0.3),
                      fontVariantNumeric: "tabular-nums",
                    },
                    children: [x.pct, "%"],
                  }),
                ],
              },
              x.name,
            ),
          ),
        }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: s,
            top: a(322.5),
            fontSize: e(22),
            lineHeight: `${e(26)}px`,
            fontWeight: 500,
            color: o(0.55),
          },
          children: "Your Accounts",
        }),
        bt.map((x, y) => {
          const O = l + y * e(85.46),
            N = O + h / 2;
          return t.jsxs(
            m.Fragment,
            {
              children: [
                t.jsx("div", {
                  style: {
                    position: "absolute",
                    left: s,
                    top: O,
                    width: n,
                    height: h,
                    borderRadius: 4,
                    border: `0.5px solid ${o(0.09)}`,
                    background: o(y === 0 ? 0.035 : 0.018),
                  },
                }),
                t.jsx("span", {
                  style: {
                    position: "absolute",
                    left: b,
                    top: p(y),
                    width: d,
                    height: d,
                    borderRadius: "50%",
                    background: x.color,
                    animation: y === 1 ? tt("wsOld") : void 0,
                  },
                }),
                y === 1 &&
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: b,
                      top: p(y),
                      width: d,
                      height: d,
                      borderRadius: "50%",
                      background: It,
                      opacity: 0,
                      animation: tt("wsNew"),
                    },
                  }),
                t.jsxs("div", {
                  style: {
                    position: "absolute",
                    left: b + d + e(14.08),
                    top: N - 4.5,
                    height: 9,
                    display: "flex",
                    alignItems: "center",
                    gap: e(7.04),
                  },
                  children: [
                    t.jsx("span", {
                      style: { fontSize: e(15), lineHeight: `${e(15)}px`, fontWeight: 500, color: o(0.62) },
                      children: x.name,
                    }),
                    t.jsx("span", {
                      style: {
                        ...c,
                        position: "static",
                        fontSize: 5.5,
                        color: o(0.34),
                        padding: "0 1.75px",
                        lineHeight: "9px",
                        borderRadius: 1.5,
                        background: o(0.06),
                      },
                      children: x.type,
                    }),
                    y === 0 &&
                      t.jsx("span", {
                        style: {
                          ...c,
                          position: "static",
                          fontSize: 5.5,
                          color: L(0.9),
                          padding: "0 1.75px",
                          lineHeight: "9px",
                          borderRadius: 1.5,
                          background: L(0.1),
                        },
                        children: "ACTIVE",
                      }),
                  ],
                }),
                t.jsx("span", {
                  style: {
                    ...Z,
                    left: void 0,
                    right: I.w - (s + n - e(215)),
                    top: N - 7.94,
                    fontSize: 9,
                    color: o(0.8),
                  },
                  children: x.usd,
                }),
                t.jsxs("span", {
                  style: {
                    ...Z,
                    left: void 0,
                    right: I.w - (s + n - e(215)),
                    top: N + 1.94,
                    fontSize: 6,
                    color: o(0.3),
                  },
                  children: [x.pct, "% of equity"],
                }),
                t.jsx("div", {
                  style: {
                    position: "absolute",
                    left: s + n - e(214.7),
                    top: N - e(14.08),
                    width: e(100),
                    height: e(28.16),
                    borderRadius: 3,
                    border: `0.5px solid ${o(0.14)}`,
                    background: o(0.03),
                  },
                }),
                y !== 0 &&
                  t.jsx("div", {
                    style: {
                      position: "absolute",
                      left: s + n - e(109.4),
                      top: N - e(14.08),
                      width: e(100),
                      height: e(28.16),
                      borderRadius: 3,
                      border: `0.5px solid ${o(0.14)}`,
                      background: o(0.03),
                    },
                  }),
              ],
            },
            x.name,
          );
        }),
        t.jsx("div", {
          style: {
            position: "absolute",
            left: s,
            top: a(790),
            width: n,
            height: e(49),
            borderRadius: 4,
            border: `0.5px dashed ${o(0.16)}`,
          },
        }),
        t.jsxs("div", {
          style: {
            position: "absolute",
            left: u.x,
            top: u.y,
            width: u.w,
            height: u.h,
            transformOrigin: "12% 0%",
            opacity: 0,
            transform: "scale(0.95)",
            animation: tt("wsPick"),
            zIndex: 4,
          },
          children: [
            t.jsx("div", {
              style: {
                position: "absolute",
                inset: 0,
                borderRadius: 2,
                border: `0.5px solid ${o(0.18)}`,
                background: vt,
                boxShadow: "0 14px 34px rgba(0, 0, 0, 0.5)",
              },
            }),
            ve.map((x, y) =>
              t.jsx(
                "span",
                {
                  style: {
                    position: "absolute",
                    left: e(7.04) + y * e(25.04),
                    top: e(7.04),
                    width: e(18),
                    height: e(18),
                    borderRadius: "50%",
                    background: x,
                  },
                },
                x,
              ),
            ),
            t.jsx("span", {
              style: {
                position: "absolute",
                left: e(7.04) - 1.5,
                top: e(7.04) - 1.5,
                width: e(18) + 3,
                height: e(18) + 3,
                borderRadius: "50%",
                border: `0.75px solid ${o(0.85)}`,
                opacity: 0,
                animation: tt("wsHov"),
              },
            }),
          ],
        }),
        t.jsx(At, {
          pts: [
            [s + n, g.y],
            [730, g.y],
            [730, a(300)],
          ],
          label: "RECOLOR",
          labelAt: [716, a(288)],
        }),
        t.jsx(zt, { park: [700, 424], move: "wsCur", press: "wsPress", dip: "wsDip", dur: 6 }),
        t.jsx("span", { style: { ...c, left: 40, top: 14, color: o(0.3) }, children: "SUB-ACCOUNTS ┬╖ 5" }),
        t.jsx("span", {
          style: {
            ...c,
            left: void 0,
            right: 40,
            top: 14,
            color: o(0.3),
            opacity: 0,
            animation: tt("wsNew"),
          },
          children: "RECOLORED",
        }),
      ],
    });
  },
  Re = [
    "@@:      :@@     :@@@@@@:",
    " @@:    :@@          :@@ ",
    "  @@:  :@@           :@@ ",
    "   @@::@@         @@@@:  ",
    "    @@@@:            :@@ ",
    "     @@:             :@@ ",
    "      @:         @@@@@:  ",
  ].join(`
`),
  _t = ["THEMES", "MARKETS", "ACCOUNTS", "LAYOUT", "ORDERS"],
  Te = () => {
    const e = _t.map((i) => i.length * 4.8),
      s = e.reduce((i, l) => i + l, 0) + (_t.length - 1) * 18;
    let n = (I.w - s) / 2;
    const a = e.map((i) => {
      const l = n;
      return ((n += i + 18), l);
    });
    return t.jsxs(ft, {
      children: [
        Array.from({ length: 26 }, (i, l) =>
          t.jsx(
            "span",
            {
              style: {
                position: "absolute",
                left: ((l * 131 + 40) % 760) + 20,
                top: ((l * 173 + 60) % 380) + 30,
                width: l % 3 === 0 ? 2 : 1.5,
                height: l % 3 === 0 ? 2 : 1.5,
                borderRadius: "50%",
                background: o(0.1 + (l % 4) * 0.04),
                animation: `wiDrift ${7 + (l % 5)}s ease-in-out ${-(l % 9)}s infinite alternate`,
              },
            },
            l,
          ),
        ),
        t.jsx("pre", {
          "aria-hidden": !0,
          style: {
            position: "absolute",
            left: "50%",
            top: 145,
            transform: "translateX(-50%)",
            margin: 0,
            fontFamily: "var(--font-mono)",
            fontSize: 10,
            lineHeight: 1.55,
            letterSpacing: "0.04em",
            color: o(1),
            opacity: 0.05,
            animation: "wiAscii 9s ease-in-out infinite",
            userSelect: "none",
          },
          children: Re,
        }),
        t.jsx("div", {
          style: {
            position: "absolute",
            left: 0,
            right: 0,
            top: 176,
            textAlign: "center",
            fontSize: 46,
            fontWeight: 585,
            letterSpacing: "-0.03em",
            lineHeight: 1,
            color: o(0.92),
            fontVariantNumeric: "tabular-nums",
          },
          children: t.jsx(je, { text: "Lighter v3" }),
        }),
        t.jsxs("div", {
          style: { position: "absolute", left: 240, top: 253, width: 320, height: 3, overflow: "hidden" },
          children: [
            t.jsx("span", {
              style: { position: "absolute", left: 0, top: 1, width: 320, height: 1, background: o(0.14) },
            }),
            t.jsx("span", {
              style: {
                position: "absolute",
                left: 0,
                top: 0.25,
                width: 140,
                height: 2.5,
                borderRadius: 1,
                background: `linear-gradient(90deg, transparent, ${L(0.95)}, transparent)`,
                boxShadow: `0 0 7px ${L(0.6)}, 0 0 18px ${L(0.25)}`,
                opacity: 0,
                animation: "wiBeam 6s linear infinite",
              },
            }),
          ],
        }),
        t.jsx("span", {
          style: { position: "absolute", left: 240, top: 251, width: 1, height: 7, background: o(0.22) },
        }),
        t.jsx("span", {
          style: { position: "absolute", left: 560, top: 251, width: 1, height: 7, background: o(0.22) },
        }),
        _t.map((i, l) => {
          const r = (6 * (6 + Math.min(Math.max((a[l] + e[l] / 2 - 170) / 470, 0), 1) * 38)) / 100;
          return t.jsx(
            "span",
            {
              style: {
                ...c,
                left: a[l],
                top: 282,
                fontSize: 6.5,
                color: o(0.55),
                opacity: 0.22,
                animation: `wiChap 6s ${z} infinite`,
                animationDelay: `${r.toFixed(2)}s`,
              },
              children: i,
            },
            i,
          );
        }),
      ],
    });
  },
  St = (e) => (e < 0 ? 0 : e > 1 ? 1 : e),
  xt = (e, s, n) => e + (s - e) * n,
  Pt = (e) => 1 - Math.pow(1 - e, 4);
function Ee(e, s, n, a = Pt) {
  return n <= 0 ? (e >= s ? 1 : 0) : a(St((e - s) / n));
}
function $e(e, s = {}) {
  const { speed: n = 1, loop: a = !1, paused: i = !1 } = s,
    [l, h] = m.useState(0),
    r = m.useRef(0);
  return (
    m.useEffect(() => {
      if (i) return;
      let b = 0,
        p = 0,
        g = r.current >= e ? 0 : r.current;
      const u = (x) => {
        p || (p = x);
        const y = g + ((x - p) / 1e3) * n;
        y < e
          ? ((r.current = y), h(y), (b = requestAnimationFrame(u)))
          : a
            ? ((p = x), (g = 0), (r.current = 0), h(0), (b = requestAnimationFrame(u)))
            : ((r.current = e), h(e));
      };
      return ((b = requestAnimationFrame(u)), () => cancelAnimationFrame(b));
    }, [e, n, a, i]),
    l
  );
}
function Ie(e, s) {
  const [n, a] = m.useState({}),
    i = JSON.stringify(s);
  return (
    m.useEffect(() => {
      const l = e.current;
      if (!l) return;
      let h = 0;
      const r = () => {
        const d = {};
        for (const [b, p] of Object.entries(s)) {
          const g = l.querySelector(p);
          if (!g) continue;
          const u = _e(g, l);
          u && (d[b] = u);
        }
        a((b) => (Ce(b, d) ? b : d));
      };
      return (r(), (h = requestAnimationFrame(r)), () => cancelAnimationFrame(h));
    }, [i]),
    n
  );
}
function _e(e, s) {
  let n = 0,
    a = 0,
    i = e,
    l = 0;
  for (; i && i !== s && l++ < 60;) {
    ((n += i.offsetLeft), (a += i.offsetTop));
    const h = i.offsetParent;
    let r = i.parentElement;
    for (; r && r !== h && l++ < 300;) ((n -= r.scrollLeft), (a -= r.scrollTop), (r = r.parentElement));
    i = h;
  }
  return i !== s ? null : { x: n + e.offsetWidth / 2, y: a + e.offsetHeight / 2 };
}
function Ce(e, s) {
  const n = Object.keys(e),
    a = Object.keys(s);
  return n.length !== a.length
    ? !1
    : n.every((i) => s[i] && Math.abs(e[i].x - s[i].x) < 0.5 && Math.abs(e[i].y - s[i].y) < 0.5);
}
function Oe(e, s, n) {
  const a = (x) => (x.target && n[x.target] ? n[x.target] : { x: x.x ?? 0, y: x.y ?? 0 });
  if (!s.length) return null;
  if (e < s[0].at) return { ...a(s[0]), press: 0, dip: 0, visible: !1 };
  let i = s[0],
    l = s[0];
  for (let x = 0; x < s.length; x++) e >= s[x].at && ((i = s[x]), (l = s[x + 1] ?? s[x]));
  const h = l.travel ?? 0.55,
    r = l === i ? 1 : Pt(St((e - l.at + h) / h)),
    d = a(i),
    b = a(l),
    p = i.press ? St((e - i.at) / 0.42) : 0,
    g = (x) => (x.press ? Math.sin(St((e - x.at + 0.12) / 0.24) * Math.PI) * 0.06 : 0),
    u = Math.max(g(i), l === i ? 0 : g(l));
  return { x: d.x + (b.x - d.x) * r, y: d.y + (b.y - d.y) * r, press: p, dip: u, visible: !0 };
}
const at = { x: 42, y: 65.7, w: 716, h: 502 },
  f = LAYOUT_FRAMES,
  Le = [
    ["GROSS PROFIT", "$4.72B"],
    ["NET INCOME", "$491M"],
    ["EPS", "$0.15"],
    ["FCF", "$1.44B"],
  ],
  Ne = [0.6, 0.74, 0.43, 0.62, 0.55, 0.72, 0.44, 0.52],
  Me = [0.72, 0.71, 0.27, 0.4, 0.52, 0.66, 0.27, 0.33],
  We = [112, 119, 122, 125, 123, 127, 129, 133],
  Yt = [43, 45, 46, 48, 47, 49, 50, 52],
  Rt = [92, 64, 98, 78, 70],
  kt = { x: 12, y: 24 },
  Ct = [0, 38, 84, 130],
  ze = {
    TRADING: [52.2, 31.9],
    ORDERBOOK: [49.3, 43.5, 37.7, 37.7],
    DISPLAY: [29, 23.2, 31.9, 40.6],
    SOUNDS: [34.8, 34.8, 31.9],
    DEPOSIT: [40.6],
  },
  gt = (e) => ({ left: e.l, top: e.t, width: e.w - 4, height: Math.max(e.h - 4, 3) }),
  Nt = {
    pressFooter: 1.08,
    grab: 1.89,
    drop: 4.14,
    pressMF: 5.13,
    pressSwap: 7.65,
    pressClassic: 10.17,
    pressGear: 10.98,
    pressToggle: 11.97,
    pressFin: 15.12,
    stripOff: 16.56,
    park: 17,
    duration: 18,
  },
  Fe = { lag: 0.09, morph: 0.6, dragDur: 0.72, fade: 0.5, drawerSlide: 14 };
function Qt(e, s, n, a, i) {
  let l = s;
  for (const h of n) {
    if (e <= h.at) break;
    const r = Ee(e, h.at, h.dur ?? a, Pt);
    if (r >= 1) {
      l = h.to;
      continue;
    }
    return i(l, h.to, r);
  }
  return l;
}
const M = (e, s, n, a) => Qt(e, s, n, a, xt),
  ht = (e, s, n, a) =>
    Qt(e, s, n, a, (i, l, h) => ({
      l: xt(i.l, l.l, h),
      t: xt(i.t, l.t, h),
      w: xt(i.w, l.w, h),
      h: xt(i.h, l.h, h),
    })),
  Pe = {
    footer: '[data-lt="footer"]',
    grip: '[data-lt="grip"]',
    classic: '[data-lt="classic"]',
    mf: '[data-lt="mf"]',
    swap: '[data-lt="swap"]',
    toggle: '[data-lt="toggle"]',
  };
function De(e) {
  const [s, n] = m.useState({
    classic: { l: 329.8, w: 34.3 },
    mf: { l: 362.3, w: 59.5 },
    swap: { l: 420.1, w: 23.4 },
  });
  return (
    m.useLayoutEffect(() => {
      const a = { ...s };
      for (const i of ["classic", "mf", "swap"]) {
        const l = e[i].current;
        if (!l) return;
        a[i] = { l: l.offsetLeft - 4.5, w: l.offsetWidth + 9 };
      }
      n(a);
    }, []),
    s
  );
}
const He = ({ at: e }) => {
    if (!e || !e.visible) return null;
    const s = e.press > 0 && e.press < 1;
    return t.jsxs("span", {
      style: {
        position: "absolute",
        left: 0,
        top: 0,
        zIndex: 8,
        transform: `translate3d(${e.x}px, ${e.y}px, 0)`,
        filter: "drop-shadow(0 2px 6px rgba(0, 0, 0, 0.55))",
      },
      children: [
        s &&
          t.jsx("span", {
            style: {
              position: "absolute",
              left: -6,
              top: -6,
              width: 12,
              height: 12,
              borderRadius: "50%",
              border: `1px solid ${L(0.8)}`,
              transform: `scale(${0.4 + e.press * 1.4})`,
              opacity: 0.55 * (1 - e.press),
            },
          }),
        t.jsx("svg", {
          width: 18,
          height: 18,
          viewBox: "0 0 18 18",
          fill: "none",
          style: {
            display: "block",
            marginLeft: -2,
            marginTop: -2,
            transformOrigin: "2px 2px",
            transform: `scale(${1 - (e.dip ?? 0)})`,
          },
          children: t.jsx("path", {
            d: "M15.154,6.253L3.731,2.079h0c-.477-.175-.994-.058-1.353,.3-.357,.358-.473,.876-.298,1.352L6.254,15.154c.188,.517,.66,.846,1.208,.846,.009,0,.019,0,.027,0,.559-.011,1.03-.362,1.2-.895l1.556-4.86,4.859-1.555c.532-.17,.884-.642,.896-1.201,.011-.559-.321-1.044-.846-1.236Z",
            fill: o(0.95),
          }),
        }),
      ],
    });
  },
  Xt = () =>
    t.jsxs(t.Fragment, {
      children: [
        t.jsx("span", {
          style: {
            ...lt(5, 0, 3, 0),
            top: "50%",
            marginTop: -1.5,
            background: L(0.85),
            animation: "wnLive 2.6s ease-out infinite",
          },
        }),
        t.jsx("div", {
          style: {
            position: "absolute",
            left: 13,
            top: 0,
            right: 0,
            height: "100%",
            overflow: "hidden",
            maskImage:
              "linear-gradient(90deg, transparent 0, black 10px, black calc(100% - 14px), transparent 100%)",
            WebkitMaskImage:
              "linear-gradient(90deg, transparent 0, black 10px, black calc(100% - 14px), transparent 100%)",
          },
          children: t.jsx("div", {
            style: {
              display: "flex",
              alignItems: "center",
              height: "100%",
              width: "max-content",
              animation: "wnTrack 18s linear infinite",
            },
            children: [...Rt, ...Rt].map((e, s) =>
              t.jsx(
                "span",
                {
                  style: {
                    display: "block",
                    width: e,
                    height: 1.5,
                    borderRadius: 1,
                    marginRight: 22,
                    background: o(s % 2 ? 0.13 : 0.2),
                  },
                },
                s,
              ),
            ),
          }),
        }),
      ],
    }),
  yt = ({ r: e, a: s = 0.09, bg: n, children: a }) =>
    t.jsx("div", {
      style: {
        position: "absolute",
        ...gt(e),
        borderRadius: 3,
        border: `0.5px solid ${o(s)}`,
        background: n,
        overflow: "visible",
      },
      children: a,
    }),
  Be = ({ t: e, dials: s }) => {
    const n = { ...Fe, ...s },
      a = Nt,
      i = m.useRef(null),
      l = m.useRef(null),
      h = m.useRef(null),
      r = m.useRef(null),
      d = { classic: l, mf: h, swap: r },
      b = a.pressMF + n.lag,
      p = a.pressSwap + n.lag,
      g = a.pressClassic + n.lag,
      u = a.pressToggle + n.lag,
      x = a.pressFin + n.lag,
      y = a.stripOff,
      O = a.grab + 0.27,
      N = ht(
        e,
        f.A.chart,
        [
          { at: O, to: f.D.chart, dur: n.dragDur },
          { at: b, to: f.M.chart },
          { at: p, to: f.S.chart },
          { at: g, to: f.A.chart },
          { at: u, to: f.A2.chart },
          { at: y, to: f.A.chart },
        ],
        n.morph,
      ),
      P = ht(
        e,
        f.A.pos,
        [
          { at: O, to: f.D.pos, dur: n.dragDur },
          { at: b, to: f.M.pos },
          { at: p, to: f.S.pos },
          { at: g, to: f.A.pos },
          { at: u, to: f.A2.pos },
          { at: y, to: f.A.pos },
        ],
        n.morph,
      ),
      R = ht(
        e,
        f.A.book,
        [
          { at: b, to: f.M.book },
          { at: p, to: f.S.details },
          { at: g, to: f.A.book },
          { at: u, to: f.A2.book },
          { at: y, to: f.A.book },
        ],
        n.morph,
      ),
      k = ht(
        e,
        f.A.ticket,
        [
          { at: b, to: f.M.ticket },
          { at: p, to: f.S.ticket },
          { at: g, to: f.A.ticket },
          { at: u, to: f.A2.ticket },
          { at: y, to: f.A.ticket },
        ],
        n.morph,
      ),
      _ = ht(
        e,
        f.A.acct,
        [
          { at: b, to: f.M.acct },
          { at: p, to: f.S.acct },
          { at: g, to: f.A.acct },
          { at: u, to: f.A2.acct },
          { at: y, to: f.A.acct },
        ],
        n.morph,
      ),
      D = ht(
        e,
        f.A.favs,
        [
          { at: b, to: f.M.favs },
          { at: p, to: f.S.favs },
          { at: g, to: f.A.favs },
          { at: u, to: f.A2.favs },
          { at: y, to: f.A.favs },
        ],
        n.morph,
      ),
      q = M(
        e,
        0,
        [
          { at: b, to: 1 },
          { at: p, to: 0 },
        ],
        n.fade,
      ),
      W = M(
        e,
        0,
        [
          { at: p, to: 1 },
          { at: g, to: 0 },
        ],
        n.fade,
      ),
      J = M(
        e,
        0,
        [
          { at: u, to: 1 },
          { at: y, to: 0 },
        ],
        n.fade,
      ),
      et = M(e, 0, [{ at: x, to: 1 }], 0.36),
      st = 1 - W,
      it = M(
        e,
        0,
        [
          { at: a.pressFooter + 0.05, to: 1, dur: 0.3 },
          { at: 16.74, to: 0, dur: 0.54 },
        ],
        0.3,
      ),
      H = M(
        e,
        0,
        [
          { at: a.grab - 0.18, to: 0.8, dur: 0.3 },
          { at: a.drop + 0.36, to: 0, dur: 0.5 },
        ],
        0.3,
      ),
      ct = M(
        e,
        0.18,
        [
          { at: a.pressFooter + 0.09, to: 0.95, dur: 0.27 },
          { at: a.drop + 0.7, to: 0.18, dur: 0.7 },
        ],
        0.3,
      ),
      K = M(
        e,
        0,
        [
          { at: a.pressGear + 0.2, to: 1, dur: 0.45 },
          { at: 14.04, to: 0, dur: 0.45 },
        ],
        0.45,
      ),
      j = M(e, 0, [{ at: u, to: 1, dur: 0.3 }], 0.3),
      S = M(
        e,
        0,
        [
          { at: b, to: 1, dur: 0.54 },
          { at: p, to: 0, dur: 0.54 },
          { at: u, to: 1, dur: 0.54 },
          { at: y, to: 0, dur: 0.54 },
        ],
        0.54,
      ),
      T = M(
        e,
        0,
        [
          { at: b + 0.54, to: 1, dur: 0.36 },
          { at: b + 1.6, to: 0, dur: 0.54 },
        ],
        0.36,
      ),
      C = M(
        e,
        0,
        [
          { at: p + 0.18, to: 1, dur: 0.45 },
          { at: g, to: 0, dur: 0.45 },
        ],
        0.45,
      ),
      A = M(
        e,
        1,
        [
          { at: b, to: 0.35, dur: 0.36 },
          { at: g, to: 1, dur: 0.36 },
        ],
        0.36,
      ),
      V = M(
        e,
        0.35,
        [
          { at: b, to: 1, dur: 0.36 },
          { at: p, to: 0.35, dur: 0.36 },
        ],
        0.36,
      ),
      ot = M(
        e,
        0.35,
        [
          { at: p, to: 1, dur: 0.36 },
          { at: g, to: 0.35, dur: 0.36 },
        ],
        0.36,
      ),
      F = De(d),
      te = M(
        e,
        F.classic.l,
        [
          { at: b, to: F.mf.l, dur: 0.36 },
          { at: p, to: F.swap.l, dur: 0.36 },
          { at: g, to: F.classic.l, dur: 0.36 },
        ],
        0.36,
      ),
      ee = M(
        e,
        F.classic.w,
        [
          { at: b, to: F.mf.w, dur: 0.36 },
          { at: p, to: F.swap.w, dur: 0.36 },
          { at: g, to: F.classic.w, dur: 0.36 },
        ],
        0.36,
      ),
      se = Ie(i, Pe),
      Tt = { x: f.A.chart.l + (f.A.chart.w - 4) / 2, y: f.A.chart.t + f.A.chart.h - 4 },
      wt = { x: Tt.x, y: f.D.chart.t + f.D.chart.h - 4 },
      Dt = { x: f.A2.chart.l + kt.x + Ct[3] + 20, y: f.A2.chart.t + kt.y + 3 },
      oe = [
        { at: 0, x: 690, y: 330 },
        { at: a.pressFooter, target: "footer", x: 546, y: 420, travel: 0.7, press: !0 },
        { at: a.grab, target: "grip", x: Tt.x, y: Tt.y, travel: 0.7, press: !0 },
        { at: O + n.dragDur, x: wt.x, y: wt.y, travel: n.dragDur },
        { at: a.drop, x: wt.x, y: wt.y, travel: 0.05, press: !0 },
        { at: a.pressMF, target: "mf", x: 391.3, y: 398.6, travel: 0.75, press: !0 },
        { at: a.pressSwap, target: "swap", x: 431.5, y: 398.6, travel: 0.7, press: !0 },
        { at: a.pressClassic, target: "classic", x: 346.6, y: 398.6, travel: 0.7, press: !0 },
        { at: a.pressGear, x: 681, y: 34.3, travel: 0.6, press: !0 },
        { at: a.pressToggle, target: "toggle", x: 738.7, y: 269.3, travel: 0.75, press: !0 },
        { at: a.pressFin, x: Dt.x, y: Dt.y, travel: 1.1, press: !0 },
        { at: a.park, x: 690, y: 330, travel: 0.8 },
      ],
      ne = Oe(e, oe, se),
      nt = { l: f.A.chart.l, t: f.A.chart.t, w: f.A.chart.w - 4, h: f.D.chart.h - 4 };
    return t.jsx(ft, {
      children: t.jsxs("div", {
        ref: i,
        className: "absolute inset-0",
        children: [
          t.jsx("div", {
            style: {
              position: "absolute",
              left: nt.l,
              top: nt.t,
              width: nt.w,
              height: nt.h,
              borderRadius: 3,
              border: `1px dashed ${o(0.3)}`,
              opacity: H,
            },
          }),
          t.jsx("div", {
            className: "absolute inset-0",
            style: { opacity: H },
            children: t.jsx(Wt, {
              x: nt.l + nt.w + 10,
              y1: f.A.chart.t + f.A.chart.h - 4,
              y2: nt.t + nt.h,
              num: "2",
            }),
          }),
          t.jsx(Jt, { active: 0, lit: 2, gear: !0 }),
          t.jsx("div", {
            style: {
              position: "absolute",
              left: 40,
              top: 45.7,
              width: 720,
              height: 18,
              background: `linear-gradient(180deg, ${o(0.022)}, transparent)`,
            },
          }),
          t.jsx("span", {
            style: {
              position: "absolute",
              left: 40,
              top: 63.7,
              width: 720,
              height: 0.5,
              background: o(0.05),
            },
          }),
          t.jsxs("div", {
            style: {
              position: "absolute",
              left: 575,
              top: 29,
              width: 178,
              height: 389,
              zIndex: 6,
              opacity: K,
              transform: `translateX(${(1 - K) * n.drawerSlide}px)`,
            },
            children: [
              t.jsx("div", {
                style: {
                  position: "absolute",
                  inset: 0,
                  borderRadius: 3,
                  border: `0.5px solid ${o(0.18)}`,
                  background: "rgba(var(--showcase-elevated-rgb), 0.99)",
                },
              }),
              t.jsx("span", {
                style: { ...c, left: 5.3, top: 6.4, fontSize: 7, color: o(0.78) },
                children: "Settings",
              }),
              t.jsx("span", {
                style: {
                  position: "absolute",
                  left: 165,
                  top: 9.4,
                  width: 6,
                  height: 0.5,
                  background: o(0.4),
                  transform: "rotate(45deg)",
                },
              }),
              t.jsx("span", {
                style: {
                  position: "absolute",
                  left: 165,
                  top: 9.4,
                  width: 6,
                  height: 0.5,
                  background: o(0.4),
                  transform: "rotate(-45deg)",
                },
              }),
              t.jsx("span", {
                style: {
                  position: "absolute",
                  left: 0,
                  top: 19.8,
                  width: 178,
                  height: 0.5,
                  background: o(0.1),
                },
              }),
              [
                ["TRADING", 2, 25.1],
                ["ORDERBOOK", 4, 84.3],
                ["DISPLAY", 4, 182],
                ["SOUNDS", 3, 279.7],
                ["DEPOSIT", 1, 358.2],
              ].map(([w, E, Q]) =>
                t.jsxs(
                  m.Fragment,
                  {
                    children: [
                      t.jsx("span", {
                        style: { ...c, left: 9, top: Q, fontSize: 5.5, color: o(0.26) },
                        children: w,
                      }),
                      Array.from({ length: E }, (Ht, pt) => {
                        const U = Q + 13.7 + pt * 19.3,
                          G = w === "DISPLAY" && pt === 2;
                        return t.jsxs(
                          m.Fragment,
                          {
                            children: [
                              t.jsx("span", {
                                style: {
                                  position: "absolute",
                                  left: 0,
                                  top: U + 15.6,
                                  width: 178,
                                  height: 0.5,
                                  background: o(0.06),
                                },
                              }),
                              t.jsx("span", {
                                style: {
                                  position: "absolute",
                                  left: 5.3,
                                  top: U,
                                  width: 12,
                                  height: 12,
                                  borderRadius: 1.5,
                                  border: `0.5px solid ${o(G ? 0.22 : 0.13)}`,
                                },
                              }),
                              t.jsx("span", {
                                style: {
                                  position: "absolute",
                                  left: 20,
                                  top: U + 3.7,
                                  width: ze[w][pt],
                                  height: 4.4,
                                  borderRadius: 1,
                                  background: o(G ? 0.42 : 0.16),
                                },
                              }),
                              t.jsx("span", {
                                "data-lt": G ? "toggle" : void 0,
                                style: {
                                  position: "absolute",
                                  left: 154.7,
                                  top: U + 2,
                                  width: 18,
                                  height: 8,
                                  borderRadius: 4,
                                  border: `0.5px solid ${o(G ? 0.22 : 0.1)}`,
                                },
                              }),
                              G &&
                                t.jsx("span", {
                                  style: {
                                    position: "absolute",
                                    left: 154.7,
                                    top: U + 2,
                                    width: 18,
                                    height: 8,
                                    borderRadius: 4,
                                    background: L(0.32),
                                    opacity: j,
                                  },
                                }),
                              t.jsx("span", {
                                style: {
                                  position: "absolute",
                                  left: G ? xt(155.7, 162.7, j) : 155.7,
                                  top: U + 3,
                                  width: 9,
                                  height: 6,
                                  borderRadius: 3,
                                  background: o(G ? 0.8 : 0.2),
                                },
                              }),
                            ],
                          },
                          pt,
                        );
                      }),
                    ],
                  },
                  w,
                ),
              ),
            ],
          }),
          t.jsx("div", {
            style: {
              position: "absolute",
              ...gt(f.A2.strip),
              borderRadius: 2,
              border: `0.5px solid ${o(0.12)}`,
              opacity: J,
              overflow: "hidden",
            },
            children: t.jsx(Xt, {}),
          }),
          t.jsxs("div", {
            style: {
              position: "absolute",
              left: 256,
              top: 28,
              width: 380,
              height: 26,
              borderRadius: 3,
              border: `0.5px solid ${o(0.16)}`,
              backgroundColor: vt,
              backgroundImage: `linear-gradient(180deg, ${o(0.035)}, ${o(0.01)})`,
              overflow: "hidden",
              zIndex: 3,
              opacity: S,
              transform: `translateY(${-3 * (1 - S)}px)`,
            },
            children: [
              t.jsx("span", {
                style: {
                  ...lt(10, 11, 4, 0),
                  background: L(0.85),
                  animation: "wnLive 2.6s ease-out infinite",
                },
              }),
              t.jsx("span", {
                style: { ...c, left: 20, top: 10, fontSize: 6, color: o(0.55) },
                children: "LIVE",
              }),
              t.jsx("span", {
                style: { position: "absolute", left: 44, top: 6, width: 1, height: 14, background: o(0.12) },
              }),
              t.jsx("div", {
                style: {
                  position: "absolute",
                  left: 54,
                  top: 0,
                  right: 0,
                  height: "100%",
                  overflow: "hidden",
                  maskImage:
                    "linear-gradient(90deg, transparent 0, black 16px, black calc(100% - 20px), transparent 100%)",
                  WebkitMaskImage:
                    "linear-gradient(90deg, transparent 0, black 16px, black calc(100% - 20px), transparent 100%)",
                },
                children: t.jsx("div", {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    width: "max-content",
                    animation: "wnTrack 18s linear infinite",
                  },
                  children: [...Rt, ...Rt].map((w, E) =>
                    t.jsxs(
                      "div",
                      {
                        style: { display: "flex", alignItems: "center", gap: 6, marginRight: 26 },
                        children: [
                          t.jsx("span", {
                            style: {
                              display: "block",
                              width: 11,
                              height: 8,
                              borderRadius: 1,
                              border: `0.5px solid ${o(0.16)}`,
                            },
                          }),
                          t.jsx("span", {
                            style: {
                              display: "block",
                              width: w,
                              height: 2.5,
                              borderRadius: 1,
                              background: o(0.2),
                            },
                          }),
                        ],
                      },
                      E,
                    ),
                  ),
                }),
              }),
            ],
          }),
          t.jsx("span", {
            style: { ...c, left: 256, top: 30, fontSize: 6.5, color: L(0.7), opacity: S, zIndex: 4 },
            children: "MARKET NEWS",
          }),
          t.jsx("div", { style: { ...B(136, 34, 106, 20, 0.13, 4), background: o(0.02) } }),
          t.jsx("span", { style: { ...lt(146, 40, 8, 0.3) } }),
          t.jsx("span", {
            style: { ...c, left: 160, top: 41, fontSize: 6.5, color: o(0.5), opacity: 1 - C },
            children: "ETH-PERP ┬╖ 20X",
          }),
          t.jsxs("span", {
            style: { position: "absolute", left: 160, top: 41, opacity: C },
            children: [
              t.jsxs("span", {
                style: { ...c, position: "static", fontSize: 6.5, color: o(0.5) },
                children: ["ETH / USDC", " "],
              }),
              t.jsx("span", {
                style: { ...c, position: "static", fontSize: 6.5, color: L(0.75) },
                children: "SPOT",
              }),
            ],
          }),
          t.jsx("div", {
            style: { position: "absolute", ...gt(D), borderRadius: 2, border: `0.5px solid ${o(0.09)}` },
            children: [0, 1, 2].map((w) =>
              t.jsx(
                "span",
                {
                  style: {
                    position: "absolute",
                    left: 8 + w * 26,
                    top: "50%",
                    marginTop: -1,
                    width: 18,
                    height: 2,
                    borderRadius: 1,
                    background: o(0.18),
                  },
                },
                w,
              ),
            ),
          }),
          t.jsxs("div", {
            style: {
              position: "absolute",
              ...gt(f.M.news),
              borderRadius: 2,
              border: `0.5px solid ${o(0.1)}`,
              opacity: q,
              overflow: "hidden",
            },
            children: [
              t.jsx("span", {
                style: {
                  position: "absolute",
                  inset: -1,
                  borderRadius: 2,
                  border: `1px solid ${L(0.55)}`,
                  opacity: T,
                },
              }),
              t.jsx(Xt, {}),
            ],
          }),
          t.jsxs("div", {
            style: {
              position: "absolute",
              ...gt(f.M.dock),
              borderRadius: 3,
              border: `0.5px solid ${o(0.09)}`,
              opacity: q,
            },
            children: [
              t.jsx("span", { style: { ...c, left: 8, top: 8, color: o(0.2) }, children: "MARKETS" }),
              t.jsx("span", {
                style: {
                  position: "absolute",
                  left: 8,
                  top: 24,
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  border: `0.5px solid ${o(0.25)}`,
                },
              }),
              t.jsx("span", {
                style: {
                  position: "absolute",
                  left: 20,
                  top: 27,
                  width: 44,
                  height: 2,
                  borderRadius: 1,
                  background: o(0.12),
                },
              }),
              [0, 1, 2, 3].map((w) =>
                t.jsxs(
                  m.Fragment,
                  {
                    children: [
                      t.jsx("span", {
                        style: {
                          position: "absolute",
                          left: 8,
                          top: 46 + w * 18,
                          width: 5,
                          height: 5,
                          borderRadius: "50%",
                          background: o(0.2),
                        },
                      }),
                      t.jsx("span", {
                        style: {
                          position: "absolute",
                          left: 19,
                          top: 47 + w * 18,
                          width: w % 2 ? 40 : 52,
                          height: 2.5,
                          borderRadius: 1,
                          background: o(0.12),
                        },
                      }),
                    ],
                  },
                  w,
                ),
              ),
            ],
          }),
          t.jsxs(yt, {
            r: N,
            a: 0.22,
            bg: `color-mix(in srgb, ${dt} 92%, transparent)`,
            children: [
              t.jsx("span", {
                style: { ...c, left: 10, top: 8, color: o(0.35), opacity: st },
                children: "CHART",
              }),
              t.jsx("span", {
                style: { ...c, left: 10, top: 8, color: o(0.35), opacity: W },
                children: "PRICE",
              }),
              t.jsx("svg", {
                style: {
                  position: "absolute",
                  left: 8,
                  right: 8,
                  bottom: 6,
                  width: "calc(100% - 16px)",
                  height: "55%",
                  opacity: 1 - et * J,
                },
                viewBox: "0 0 260 60",
                preserveAspectRatio: "none",
                fill: "none",
                children: t.jsx("path", {
                  d: Zt([24, 34, 28, 44, 38, 52, 46, 58, 52, 62], 260, 56),
                  stroke: o(0.16),
                  strokeWidth: 1,
                  fill: "none",
                  strokeLinecap: "round",
                  vectorEffect: "non-scaling-stroke",
                }),
              }),
              t.jsxs("span", {
                style: { position: "absolute", left: kt.x, top: kt.y, opacity: J },
                children: [
                  ["PRICE", "FUNDING", "DETAILS", "FINANCIALS"].map((w, E) =>
                    t.jsx(
                      "span",
                      {
                        style: {
                          ...c,
                          position: "absolute",
                          left: Ct[E],
                          top: 0,
                          fontSize: 5.5,
                          color: o(E === 3 ? 0.5 : 0.25),
                          whiteSpace: "nowrap",
                        },
                        children: w,
                      },
                      w,
                    ),
                  ),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 0,
                      top: 9,
                      width: 21,
                      height: 1.5,
                      background: L(0.85),
                      opacity: 1 - et,
                    },
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: Ct[3],
                      top: 9,
                      width: 41,
                      height: 1.5,
                      background: L(0.85),
                      opacity: et,
                    },
                  }),
                ],
              }),
              t.jsxs("div", {
                style: { position: "absolute", left: 10, top: 38, right: 10, opacity: et * J },
                children: [
                  Le.map(([w, E], Q) =>
                    t.jsxs(
                      m.Fragment,
                      {
                        children: [
                          t.jsx("span", {
                            style: { ...c, left: Q * 70, top: 0, fontSize: 4.5, color: o(0.25) },
                            children: w,
                          }),
                          t.jsx("span", {
                            style: {
                              ...Z,
                              position: "absolute",
                              left: Q * 70,
                              top: 7,
                              fontSize: 6.5,
                              color: o(0.45),
                            },
                            children: E,
                          }),
                        ],
                      },
                      w,
                    ),
                  ),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 0,
                      top: 18,
                      width: 278,
                      height: 1,
                      background: o(0.07),
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 0, top: 22, fontSize: 4.5, color: o(0.3) },
                    children: "EARNINGS",
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 196,
                      top: 22,
                      width: 4,
                      height: 4,
                      borderRadius: "50%",
                      border: `0.5px solid ${o(0.3)}`,
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 204, top: 22, fontSize: 4.5, color: o(0.22) },
                    children: "EST",
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 232,
                      top: 22,
                      width: 4,
                      height: 4,
                      borderRadius: "50%",
                      background: o(0.55),
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 240, top: 22, fontSize: 4.5, color: o(0.22) },
                    children: "ACTUAL",
                  }),
                  Ne.map((w, E) => {
                    const G = (ie) => 43 - ((ie - 0.27) / 0.47) * 13;
                    return t.jsxs(
                      m.Fragment,
                      {
                        children: [
                          t.jsx("span", {
                            style: {
                              position: "absolute",
                              left: 6 + E * 37,
                              top: G(w) - 2,
                              width: 4,
                              height: 4,
                              borderRadius: "50%",
                              border: `0.5px solid ${o(0.3)}`,
                            },
                          }),
                          t.jsx("span", {
                            style: {
                              position: "absolute",
                              left: 6 + E * 37,
                              top: G(Me[E]) - 2,
                              width: 4,
                              height: 4,
                              borderRadius: "50%",
                              background: o(0.55),
                            },
                          }),
                        ],
                      },
                      E,
                    );
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 0,
                      top: 50,
                      width: 278,
                      height: 1,
                      background: o(0.07),
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 0, top: 54, fontSize: 4.5, color: o(0.3) },
                    children: "BALANCE SHEET",
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 196,
                      top: 54,
                      width: 4,
                      height: 4,
                      borderRadius: 1,
                      background: o(0.4),
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 204, top: 54, fontSize: 4.5, color: o(0.22) },
                    children: "ASSETS",
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 236,
                      top: 54,
                      width: 4,
                      height: 4,
                      borderRadius: 1,
                      background: o(0.16),
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 244, top: 54, fontSize: 4.5, color: o(0.22) },
                    children: "LIAB",
                  }),
                  We.map((w, E) => {
                    const U = (G) => (G / 133) * 18;
                    return t.jsxs(
                      m.Fragment,
                      {
                        children: [
                          t.jsx("span", {
                            style: {
                              position: "absolute",
                              left: 5 + E * 37,
                              top: 78 - U(w),
                              width: 4,
                              height: U(w),
                              borderRadius: 1,
                              background: o(0.4),
                            },
                          }),
                          t.jsx("span", {
                            style: {
                              position: "absolute",
                              left: 11 + E * 37,
                              top: 78 - U(Yt[E]),
                              width: 4,
                              height: U(Yt[E]),
                              borderRadius: 1,
                              background: o(0.16),
                            },
                          }),
                        ],
                      },
                      E,
                    );
                  }),
                ],
              }),
              [
                { left: -2.5, top: -2.5 },
                { right: -2.5, top: -2.5 },
                { left: -2.5, bottom: -2.5 },
                { right: -2.5, bottom: -2.5 },
                { left: "50%", top: -2.5, marginLeft: -2.5 },
                { left: "50%", bottom: -2.5, marginLeft: -2.5 },
                { left: -2.5, top: "50%", marginTop: -2.5 },
                { right: -2.5, top: "50%", marginTop: -2.5 },
              ].map((w, E) =>
                t.jsx(
                  "span",
                  {
                    "data-lt": E === 5 ? "grip" : void 0,
                    style: {
                      position: "absolute",
                      width: 5,
                      height: 5,
                      borderRadius: "50%",
                      background: o(0.55),
                      opacity: ct,
                      ...w,
                    },
                  },
                  E,
                ),
              ),
            ],
          }),
          t.jsxs(yt, {
            r: R,
            children: [
              t.jsx("span", {
                style: { ...c, left: 10, top: 8, color: o(0.2), opacity: st },
                children: "BOOK",
              }),
              t.jsx("span", {
                style: { ...c, left: 10, top: 8, color: o(0.28), opacity: W },
                children: "DETAILS",
              }),
              t.jsx("span", {
                style: { position: "absolute", left: 10, top: 26, width: 130, opacity: W },
                children: [
                  ["REVENUE", "$95.2B"],
                  ["EBITDA", "$1.61B"],
                  ["P/E", "48.9x"],
                ].map(([w, E], Q) =>
                  t.jsxs(
                    "span",
                    {
                      style: { position: "absolute", left: 0, top: Q * 15, width: 124, display: "flex" },
                      children: [
                        t.jsx("span", {
                          style: { ...c, position: "static", fontSize: 6, color: o(0.25) },
                          children: w,
                        }),
                        t.jsx("span", { style: { flex: 1 } }),
                        t.jsx("span", {
                          style: { ...Z, position: "static", fontSize: 6.5, color: o(0.45) },
                          children: E,
                        }),
                      ],
                    },
                    w,
                  ),
                ),
              }),
              [0, 1, 2, 3, 4].map((w) =>
                t.jsx(
                  "span",
                  {
                    style: {
                      position: "absolute",
                      left: 10,
                      top: 28 + w * 16,
                      width: w % 2 ? 56 : 76,
                      height: 3,
                      borderRadius: 1,
                      background: o(0.07),
                    },
                  },
                  w,
                ),
              ),
            ],
          }),
          t.jsxs(yt, {
            r: k,
            children: [
              t.jsx("span", {
                style: { ...c, left: 10, top: 8, color: o(0.2), opacity: st },
                children: "TICKET",
              }),
              t.jsx("span", {
                style: { ...c, left: 10, top: 8, color: o(0.28), opacity: W },
                children: "SWAP",
              }),
              t.jsxs("span", {
                style: { position: "absolute", left: 10, top: 24, opacity: W },
                children: [
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 0,
                      top: 0,
                      width: 89,
                      height: 26,
                      borderRadius: 4,
                      border: `0.5px solid ${o(0.14)}`,
                      background: o(0.02),
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 7, top: 5, fontSize: 5, color: o(0.28) },
                    children: "PAY",
                  }),
                  t.jsx("span", {
                    style: { ...Z, position: "absolute", left: 7, top: 13, fontSize: 7.5, color: o(0.6) },
                    children: "4,000.00",
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 60,
                      top: 8,
                      width: 22,
                      height: 11,
                      borderRadius: 4,
                      border: `0.5px solid ${o(0.18)}`,
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 64, top: 11, fontSize: 4.5, color: o(0.45) },
                    children: "USDC",
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 38,
                      top: 29,
                      width: 14,
                      height: 14,
                      borderRadius: "50%",
                      border: `0.5px solid ${o(0.28)}`,
                      background: vt,
                    },
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 44.5,
                      top: 33,
                      width: 1,
                      height: 6,
                      background: o(0.5),
                    },
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 42.5,
                      top: 36.5,
                      width: 4,
                      height: 1,
                      background: o(0.5),
                      transform: "rotate(45deg)",
                    },
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 45.5,
                      top: 36.5,
                      width: 4,
                      height: 1,
                      background: o(0.5),
                      transform: "rotate(-45deg)",
                    },
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 0,
                      top: 46,
                      width: 89,
                      height: 26,
                      borderRadius: 4,
                      border: `0.5px solid ${o(0.14)}`,
                      background: o(0.02),
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 7, top: 51, fontSize: 5, color: o(0.28) },
                    children: "RECEIVE",
                  }),
                  t.jsx("span", {
                    style: { ...Z, position: "absolute", left: 7, top: 59, fontSize: 7.5, color: o(0.6) },
                    children: "1.1513",
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 64,
                      top: 54,
                      width: 18,
                      height: 11,
                      borderRadius: 4,
                      border: `0.5px solid ${o(0.18)}`,
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 68, top: 57, fontSize: 4.5, color: o(0.45) },
                    children: "ETH",
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 0, top: 78, fontSize: 5, color: o(0.24) },
                    children: "RATE",
                  }),
                  t.jsx("span", {
                    style: { ...Z, position: "absolute", left: 34, top: 77, fontSize: 5.5, color: o(0.38) },
                    children: "1 ETH = 3,474.28",
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 0,
                      top: 90,
                      width: 89,
                      height: 18,
                      borderRadius: 4,
                      background: o(0.1),
                      border: `0.5px solid ${o(0.2)}`,
                    },
                  }),
                  t.jsx("span", {
                    style: { ...c, left: 34, top: 96, fontSize: 6, color: o(0.75) },
                    children: "SWAP",
                  }),
                ],
              }),
              t.jsxs("span", {
                style: { opacity: st },
                children: [
                  [0, 1].map((w) =>
                    t.jsx(
                      "span",
                      {
                        style: {
                          position: "absolute",
                          left: 10,
                          top: 26 + w * 22,
                          width: 86,
                          height: 16,
                          borderRadius: 3,
                          border: `0.5px solid ${o(0.08)}`,
                        },
                      },
                      w,
                    ),
                  ),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 10,
                      top: 76,
                      width: 86,
                      height: 14,
                      borderRadius: 3,
                      background: o(0.06),
                    },
                  }),
                ],
              }),
            ],
          }),
          t.jsxs("div", {
            className: "absolute inset-0",
            children: [
              t.jsxs(yt, {
                r: P,
                children: [
                  t.jsx("span", { style: { ...c, left: 10, top: 8, color: o(0.2) }, children: "POSITIONS" }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 10,
                      top: 28,
                      width: 84,
                      height: 3,
                      borderRadius: 1,
                      background: o(0.07),
                    },
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 108,
                      top: 28,
                      width: 60,
                      height: 3,
                      borderRadius: 1,
                      background: o(0.07),
                    },
                  }),
                  t.jsx("span", {
                    style: {
                      position: "absolute",
                      left: 10,
                      top: 42,
                      width: 64,
                      height: 3,
                      borderRadius: 1,
                      background: o(0.07),
                    },
                  }),
                ],
              }),
              t.jsxs(yt, {
                r: _,
                children: [
                  t.jsx("span", { style: { ...c, left: 10, top: 8, color: o(0.2) }, children: "ACCOUNT" }),
                  [0, 1].map((w) =>
                    t.jsx(
                      "span",
                      {
                        style: {
                          position: "absolute",
                          left: 10,
                          top: 28 + w * 14,
                          width: w ? 72 : 56,
                          height: 3,
                          borderRadius: 1,
                          background: o(0.07),
                        },
                      },
                      w,
                    ),
                  ),
                ],
              }),
            ],
          }),
          t.jsx("div", {
            style: { position: "absolute", left: 0, top: 414.5, width: 800, height: 36, background: dt },
          }),
          t.jsx("div", {
            style: {
              position: "absolute",
              left: 40,
              top: 414.5,
              width: 720,
              height: 12.6,
              borderTop: `0.5px solid ${o(0.07)}`,
            },
          }),
          t.jsx("span", { style: { ...lt(45.3, 419.5, 3, 0), background: L(0.7) } }),
          t.jsx("span", {
            style: { ...c, left: 51, top: 418.6, fontSize: 5, color: o(0.26) },
            children: "ONLINE ┬╖ MAINNET",
          }),
          t.jsx("span", {
            style: { ...c, left: 344, top: 418.6, fontSize: 5, color: o(0.18) },
            children: "OPEN MARKETS",
          }),
          t.jsx("span", {
            "data-lt": "footer",
            style: { ...c, left: 528.4, top: 418.6, fontSize: 5, color: o(0.5) },
            children: "EDIT LAYOUT",
          }),
          t.jsx("span", {
            style: { ...c, left: 588, top: 418.6, fontSize: 5, color: o(0.18) },
            children: "DOCS ┬╖ TERMS ┬╖ PRIVACY",
          }),
          t.jsxs("div", {
            className: "absolute inset-0",
            style: { opacity: it },
            children: [
              t.jsx("div", {
                style: {
                  ...B(274.5, 388.4, 252, 21.6, 0.18, 2),
                  background: "rgba(var(--showcase-elevated-rgb), 0.97)",
                },
              }),
              t.jsx("span", {
                style: { ...c, left: 279.1, top: 396, fontSize: 5.5, color: o(0.34) },
                children: "EDIT LAYOUT",
              }),
              t.jsx("span", {
                style: {
                  position: "absolute",
                  left: 328.5,
                  top: 394.8,
                  width: 0.5,
                  height: 8.8,
                  background: o(0.14),
                },
              }),
              t.jsx("span", {
                ref: d.classic,
                "data-lt": "classic",
                style: { ...c, left: 334.3, top: 396, fontSize: 5.5, color: o(0.5), opacity: A },
                children: "CLASSIC",
              }),
              t.jsx("span", {
                ref: d.mf,
                "data-lt": "mf",
                style: { ...c, left: 366.8, top: 396, fontSize: 5.5, color: o(0.5), opacity: V },
                children: "MARKET FOCUSED",
              }),
              t.jsx("span", {
                ref: d.swap,
                "data-lt": "swap",
                style: { ...c, left: 424.6, top: 396, fontSize: 5.5, color: o(0.5), opacity: ot },
                children: "SWAP",
              }),
              t.jsx("span", {
                style: {
                  position: "absolute",
                  left: 460.9,
                  top: 394.8,
                  width: 0.5,
                  height: 8.8,
                  background: o(0.14),
                },
              }),
              t.jsx("span", {
                style: { ...c, left: 465.9, top: 396, fontSize: 5.5, color: o(0.26) },
                children: "RESET",
              }),
              t.jsx("div", { style: { ...B(495, 392.2, 27, 14, 0.22, 2), background: o(0.05) } }),
              t.jsx("span", {
                style: { ...c, left: 500, top: 396, fontSize: 5.5, color: o(0.6) },
                children: "DONE",
              }),
              t.jsx(Ft, { x: te, y: 393, w: ee, h: 13, r: 2, dur: 8 }),
            ],
          }),
          t.jsx(He, { at: ne }),
        ],
      }),
    });
  },
  Ke = 10,
  Ue = ({ paused: e }) => {
    const s = $e(Nt.duration, { loop: !0, paused: e, speed: Nt.duration / Ke });
    return t.jsx(Be, { t: s });
  },
  Vt = [
    [30, 42, 38, 52, 44, 58, 50, 46],
    [60, 52, 56, 44, 48, 36, 40, 32],
    [50, 46, 52, 40, 44, 34, 38, 30],
    [20, 26, 24, 38, 44, 52, 66, 78],
    [70, 62, 66, 54, 58, 46, 44, 38],
    [64, 58, 60, 48, 52, 42, 40, 34],
  ],
  Ge = (() => {
    const s = (A) => +(A * 0.58).toFixed(2),
      n = { x: 133, y: 51, w: s(920), h: s(600) },
      a = s(38.72),
      i = s(32.18),
      l = s(35.7),
      h = s(28.16),
      r = s(31.68),
      d = n.y + a,
      b = d + i,
      p = b + l,
      g = n.y + n.h - r,
      x = [68.3, 18, 56, 38, 50, 72, 14, 25]
        .map((A) => A + 14.08)
        .reduce((A, V, ot) => {
          const F = A[ot - 1];
          return (A.push({ x: F ? F.x + F.w + s(3.52) : n.x + s(7.04), w: s(V) }), A);
        }, []),
      y = (A) => ({ l: x[A].x + s(5.28), w: x[A].w - s(10.56) }),
      O = s(24.64),
      N = s(52.8),
      P = s(24.64),
      R = s(60),
      k = s(70),
      D = n.x + n.w - s(7.04) - O,
      q = D - s(3.52) - R,
      W = q - s(8.8) - N,
      J = W - s(8.8) - k,
      et = J - s(8.8),
      st = d + i / 2,
      it = s(10.56),
      H = s(293.76),
      ct = s(75.4),
      K = s(8.8),
      j = ct + K,
      S = s(31.68),
      T = [
        [s(10.56), s(24), "l"],
        [s(41.6), s(386.64), "l"],
        [s(435.28), s(92), "r"],
        [s(534.32), s(70), "r"],
        [s(611.36), s(92), "r"],
        [s(710.4), s(104), "r"],
        [s(821.44), s(88), "r"],
      ];
    return {
      d: s,
      P: n,
      searchH: a,
      railH: i,
      colH: h,
      footH: r,
      railY: d,
      subY: b,
      bodyY: p,
      footY: g,
      railMid: st,
      tabs: x,
      uline: y,
      dirX: D,
      dirW: O,
      sortX: q,
      sortW: R,
      togX: W,
      togW: N,
      togH: P,
      cntX: J,
      clusterX: et,
      pad: it,
      cardW: H,
      cardH: ct,
      gap: K,
      pitch: j,
      rowH: S,
      COLS: T,
      HEADS: ["MARKET", "LAST PRICE", "24H", "VOLUME", "OPEN INTEREST", "8HR FUNDING"],
    };
  })(),
  Ye = () => {
    const {
        d: e,
        P: s,
        searchH: n,
        railH: a,
        colH: i,
        footH: l,
        railY: h,
        subY: r,
        bodyY: d,
        footY: b,
        railMid: p,
        tabs: g,
        uline: u,
        dirX: x,
        dirW: y,
        sortX: O,
        sortW: N,
        togX: P,
        togW: R,
        togH: k,
        cntX: _,
        clusterX: D,
        pad: q,
        cardW: W,
        cardH: J,
        gap: et,
        pitch: st,
        rowH: it,
        COLS: H,
        HEADS: ct,
      } = Ge,
      K = (R - e(3.52)) / 2;
    return t.jsxs(ft, {
      children: [
        t.jsx("div", {
          style: {
            position: "absolute",
            left: s.x,
            top: s.y,
            width: s.w,
            height: s.h,
            borderRadius: 3,
            boxShadow: `0 0 0 0.5px ${o(0.2)}`,
            background: `linear-gradient(180deg, ${o(0.024)}, ${o(0.006)} 55%, transparent)`,
          },
        }),
        t.jsx("span", {
          style: {
            ...lt(s.x + e(10.56), s.y + (n - e(14)) / 2, e(14), 0),
            border: `0.5px solid ${o(0.3)}`,
            borderRadius: "50%",
          },
        }),
        t.jsxs("div", {
          style: {
            position: "absolute",
            left: s.x + e(31.68),
            top: s.y + (n - e(14)) / 2,
            height: e(14),
            display: "flex",
            alignItems: "center",
            gap: 2,
          },
          children: [
            t.jsx("span", {
              style: {
                display: "block",
                width: 62,
                height: 2.5,
                borderRadius: 1,
                background: o(0.13),
                animation: `wmType 6s ${z} infinite`,
              },
            }),
            t.jsx("span", {
              style: {
                display: "block",
                width: 1,
                height: e(14),
                background: o(0.5),
                animation: "wmCaret 1.1s steps(1) infinite",
              },
            }),
          ],
        }),
        [0, 1].map((j) =>
          t.jsx(
            "span",
            {
              style: {
                position: "absolute",
                left: s.x + s.w - e(10.56) - e(14) + 2,
                top: s.y + n / 2,
                width: e(14) - 4,
                height: 0.5,
                background: o(0.34),
                transform: `rotate(${j ? -45 : 45}deg)`,
              },
            },
            j,
          ),
        ),
        t.jsx("span", { style: v(s.x, h - 0.5, s.w, 0.07, 0.5) }),
        g.map((j, S) => {
          const T = j.x + e(7.04) + (S === 0 ? e(16.28) : 0);
          return t.jsx(
            "span",
            {
              style: {
                ...v(T, p - 1.75, j.w - e(14.08) - (S === 0 ? e(16.28) : 0), 0.42, 3.5),
                opacity: S === 1 ? 1 : 0.55,
                animation: S === 1 ? `wmT0 6s ${z} infinite` : S === 3 ? `wmT1 6s ${z} infinite` : void 0,
              },
            },
            S,
          );
        }),
        t.jsx($t, { x: g[0].x + e(7.04) + e(5.5) - 4, y: p - 4, a: 0.34 }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: u(1).l,
            top: h + a - 1,
            width: u(1).w,
            height: 1,
            borderRadius: 1,
            background: o(0.86),
            animation: `wmUline 6s ${z} infinite`,
          },
        }),
        t.jsx(Ft, {
          x: g[1].x,
          y: h + (a - e(31.68)) / 2,
          w: g[1].w,
          h: e(31.68),
          r: 2,
          anim: `wmRing 6s ${z} infinite`,
          dur: 7,
        }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: D,
            top: h + e(5.28),
            width: 0.5,
            height: a - e(10.56),
            background: o(0.08),
          },
        }),
        t.jsx("span", {
          style: { ...c, left: _, top: p - 3, fontSize: 6, color: o(0.3) },
          children: "186 MARKETS",
        }),
        t.jsx("div", { style: { ...B(P, p - k / 2, R, k, 0, 2), background: o(0.05) } }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: P + e(1.76),
            top: p - k / 2 + e(1.76),
            width: K,
            height: k - e(3.52),
            borderRadius: 2,
            background: o(0.09),
            animation: `wmTogA 6s ${z} infinite`,
          },
        }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: P + e(1.76) + K,
            top: p - k / 2 + e(1.76),
            width: K,
            height: k - e(3.52),
            borderRadius: 2,
            background: o(0.09),
            opacity: 0.25,
            animation: `wmTogB 6s ${z} infinite`,
          },
        }),
        [0, 1, 2].map((j) =>
          t.jsx(
            "span",
            {
              style: {
                position: "absolute",
                left: P + e(1.76) + K / 2 - 3.5,
                top: p - 3 + j * 3,
                width: 7,
                height: 1,
                borderRadius: 1,
                background: o(0.5),
              },
            },
            j,
          ),
        ),
        [0, 1, 2, 3].map((j) =>
          t.jsx(
            "span",
            {
              style: {
                position: "absolute",
                left: P + e(1.76) + K + K / 2 - 3.5 + (j % 2) * 4,
                top: p - 3.5 + Math.floor(j / 2) * 4,
                width: 3,
                height: 3,
                borderRadius: 1,
                background: o(0.5),
              },
            },
            j,
          ),
        ),
        t.jsx("div", { style: { ...B(O, p - k / 2, N, k, 0, 2), background: o(0.04) } }),
        t.jsx("span", {
          style: { ...c, left: O + e(7.04), top: p - 3, fontSize: 6, color: o(0.3) },
          children: "SORT",
        }),
        t.jsx("span", { style: v(O + N - e(21), p - 1.5, e(14), 0.34, 3) }),
        t.jsx("div", { style: { ...B(x, p - k / 2, y, k, 0, 2), background: o(0.05) } }),
        t.jsx("span", {
          style: {
            position: "absolute",
            left: x + y / 2 - 0.5,
            top: p - 3.5,
            width: 1,
            height: 7,
            background: o(0.5),
          },
        }),
        [0, 1].map((j) =>
          t.jsx(
            "span",
            {
              style: {
                position: "absolute",
                left: x + y / 2 - 2 + j * 2,
                top: p + 2,
                width: 2.6,
                height: 0.8,
                background: o(0.5),
                transform: `rotate(${j ? -45 : 45}deg)`,
              },
            },
            j,
          ),
        ),
        t.jsx("span", { style: v(s.x, r - 0.5, s.w, 0.07, 0.5) }),
        [e(52), e(44), e(60), e(38)].reduce((j, S, T) => {
          const C = j.length ? j[j.length - 1].props.style : null,
            A = C ? C.left + C.width + e(5.28) : s.x + e(10.56);
          return (
            j.push(
              t.jsx(
                "span",
                {
                  style: {
                    position: "absolute",
                    left: A,
                    top: r + e(7.04),
                    width: S,
                    height: e(21.12),
                    borderRadius: 2,
                    background: o(T === 0 ? 0.11 : 0.05),
                    boxShadow: `0 0 0 0.5px ${o(T === 0 ? 0.26 : 0.15)}`,
                  },
                },
                T,
              ),
            ),
            j
          );
        }, []),
        t.jsx("span", { style: v(s.x, d - 0.5, s.w, 0.07, 0.5) }),
        t.jsxs("div", {
          style: { position: "absolute", left: s.x, top: d, width: s.w, height: b - d, overflow: "hidden" },
          children: [
            t.jsx("div", {
              style: { position: "absolute", inset: 0, opacity: 0, animation: `wmGrid 6s ${z} infinite` },
              children: Array.from({ length: 18 }, (j, S) => {
                const T = q + (S % 3) * (W + et),
                  C = q + Math.floor(S / 3) * st,
                  A = C + e(10.56),
                  V = A + e(24) + e(8.8);
                return t.jsxs(
                  m.Fragment,
                  {
                    children: [
                      t.jsx("div", { style: B(T, C, W, J, 0.08, 2) }),
                      t.jsx("span", { style: lt(T + e(10.56), A, e(24)) }),
                      t.jsx("span", { style: v(T + e(41.6), A + e(9), e(38), 0.3, 3) }),
                      t.jsx("span", { style: v(T + e(41.6) + e(43.28), A + e(9.5), e(20), 0.13, 2.5) }),
                      (S === 1 || S === 7) &&
                        t.jsx("span", {
                          style: {
                            ...B(T + e(41.6) + e(70), A + e(4), e(26), e(16), 0.2, 2),
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          },
                          children: t.jsx("span", {
                            style: { ...c, position: "static", fontSize: 5.5, color: o(0.4) },
                            children: "NEW",
                          }),
                        }),
                      t.jsx($t, { x: T + W - e(7.04) - e(7), y: C + e(7.04) + e(7) }),
                      t.jsx("span", { style: v(T + e(10.56), V + e(11), e(46), 0.22, 3.5) }),
                      t.jsx("span", { style: v(T + e(10.56) + e(52), V + e(12), e(28), 0.12, 2.5) }),
                      t.jsx(ye, {
                        x: T + W - e(10.56) - e(70),
                        y: V,
                        w: e(70),
                        h: e(24),
                        pts: Vt[S % Vt.length],
                      }),
                    ],
                  },
                  S,
                );
              }),
            }),
            t.jsxs("div", {
              style: { position: "absolute", inset: 0, animation: `wmList 6s ${z} infinite` },
              children: [
                ct.map((j, S) =>
                  t.jsx(
                    "span",
                    {
                      style: {
                        ...c,
                        left: H[S + 1][0],
                        top: (i - 6) / 2,
                        width: H[S + 1][1],
                        textAlign: H[S + 1][2] === "r" ? "right" : "left",
                        fontSize: 6,
                        color: o(0.3),
                      },
                      children: j,
                    },
                    j,
                  ),
                ),
                t.jsx("span", { style: v(0, i - 0.5, s.w, 0.07, 0.5) }),
                Array.from({ length: 14 }, (j, S) => {
                  const T = i + S * it,
                    C = T + it / 2;
                  return t.jsxs(
                    m.Fragment,
                    {
                      children: [
                        t.jsx("span", { style: v(0, T + it - 0.5, s.w, 0.055, 0.5) }),
                        t.jsx($t, { x: H[0][0] + e(12) - 4, y: C - 4, a: S % 4 === 0 ? 0.42 : 0.16 }),
                        t.jsx("span", { style: lt(H[1][0], C - e(10), e(20)) }),
                        t.jsx("span", { style: v(H[1][0] + e(27.04), C - 1.5, e(34), 0.3, 3) }),
                        t.jsx("span", { style: v(H[1][0] + e(65), C - 1, e(18), 0.11, 2.5) }),
                        [0, 1, 2, 3, 4].map((A) => {
                          const [V, ot] = H[A + 2],
                            F = e([46, 34, 40, 44, 32][A] - (S % 3) * 4);
                          return t.jsx(
                            "span",
                            { style: v(V + ot - F, C - 1.5, F, A === 1 ? 0.26 : 0.16, 3) },
                            A,
                          );
                        }),
                      ],
                    },
                    S,
                  );
                }),
              ],
            }),
          ],
        }),
        t.jsx("span", { style: v(s.x, b, s.w, 0.07, 0.5) }),
        [
          { caps: ["Γåæ", "Γåô", "ΓåÉ", "ΓåÆ"], word: "NAVIGATE" },
          { caps: ["Γå╡"], word: "SELECT" },
          { caps: ["F"], word: "FAVORITE" },
          { caps: ["ESC"], word: "CLOSE" },
        ].reduce(
          (j, S, T) => {
            let C = j.x;
            return (
              S.caps.forEach((A, V) => {
                const ot = A.length > 1 ? e(24) : e(16);
                (j.out.push(
                  t.jsx(
                    "span",
                    {
                      style: {
                        position: "absolute",
                        left: C,
                        top: b + (l - e(14.08)) / 2,
                        width: ot,
                        height: e(14.08),
                        borderRadius: 1,
                        background: o(0.06),
                        boxShadow: `inset 0 0.5px 0 0 ${o(0.06)}`,
                        fontFamily: "var(--font-mono)",
                        fontSize: 5,
                        lineHeight: `${e(14.08)}px`,
                        textAlign: "center",
                        color: o(0.42),
                      },
                      children: A,
                    },
                    `${T}-${V}`,
                  ),
                ),
                  (C += ot + 1.2));
              }),
              j.out.push(
                t.jsx(
                  "span",
                  {
                    style: { ...c, left: C + e(2), top: b + l / 2 - 3, fontSize: 5.5, color: o(0.26) },
                    children: S.word,
                  },
                  `${T}-w`,
                ),
              ),
              (j.x = C + e(2) + S.word.length * 3.6 + e(14.08)),
              j
            );
          },
          { x: s.x + e(10.56), out: [] },
        ).out,
        t.jsx("span", {
          style: {
            ...c,
            right: I.w - (s.x + s.w),
            top: s.y - 14,
            left: void 0,
            color: o(0.3),
            opacity: 0,
            animation: `wmCapG 6s ${z} infinite`,
          },
          children: "GRID VIEW",
        }),
        t.jsx("span", {
          style: {
            ...c,
            right: I.w - (s.x + s.w),
            top: s.y - 14,
            left: void 0,
            color: o(0.3),
            animation: `wmCapL 6s ${z} infinite`,
          },
          children: "LIST VIEW",
        }),
        t.jsx(Wt, { x: 117, y1: s.y, y2: s.y + s.h, num: "600" }),
        t.jsx(Mt, { x1: s.x, x2: s.x + s.w, y: s.y + s.h + 16, num: "920" }),
        t.jsx(At, {
          pts: [
            [s.x, p],
            [100, p],
            [100, 40],
          ],
          label: "CATEGORIES",
          labelAt: [46, 28],
        }),
        t.jsx(At, {
          pts: [
            [s.x + s.w, p],
            [700, p],
            [700, 40],
          ],
          label: "VIEW",
          labelAt: [692, 28],
        }),
        t.jsx(zt, { park: [706, 405], move: "wmCur", press: "wmPress", dip: "wmDip", dur: 6 }),
      ],
    });
  },
  Y = (() => {
    const s = (d) => +(d * 0.6).toFixed(2),
      n = { x: 309, y: 43, w: s(304), h: s(608) },
      a = n.x + s(5.78),
      i = s(292.44),
      l = (d) => +(n.y + d * 0.6).toFixed(2),
      h = s(95.13),
      r = i / 2;
    return { d: s, T: n, CX: a, CW: i, y: l, chipW: h, segW: r };
  })(),
  Xe = ["CONDITIONAL", "CHASE LIMIT", "TWAP", "SCALE", "ATOMIC"],
  ut = (e) => `${e} 6s ${z} infinite`,
  Ot = (e, s, n) =>
    Array.from({ length: e }, (a, i) =>
      t.jsxs(
        m.Fragment,
        {
          children: [
            t.jsx("span", {
              style: v(Y.CX, Y.y(n + i * 19.28), Y.d([58, 44, 66, 50, 62, 40, 54, 46][(i + s) % 8]), 0.09, 3),
            }),
            t.jsx("span", {
              style: {
                ...v(0, Y.y(n + i * 19.28), Y.d([40, 52, 34, 46, 38, 56, 42, 50][(i + s) % 8]), 0.17, 3),
                left: void 0,
                right: I.w - (Y.CX + Y.CW),
              },
            }),
          ],
        },
        i,
      ),
    ),
  Lt = (e, s) =>
    t.jsx("div", {
      style: {
        position: "absolute",
        left: Y.CX,
        top: Y.y(s),
        width: Y.CW,
        height: Y.d(32),
        borderRadius: 3,
        background: "rgb(var(--buy-rgb))",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      children: t.jsx("span", {
        style: { ...c, position: "static", fontSize: 6.5, fontWeight: 585, color: "var(--showcase-on-buy)" },
        children: e,
      }),
    }),
  Ve = () => {
    const { d: e, T: s, CX: n, CW: a, y: i, chipW: l, segW: h } = Y;
    return t.jsxs(ft, {
      children: [
        t.jsx("div", {
          style: {
            ...B(s.x, s.y, s.w, s.h, 0.15, 4),
            background: `linear-gradient(180deg, ${o(0.026)}, ${o(0.007)} 55%, transparent)`,
          },
        }),
        ["13x", "Cross", "Unified"].map((r, d) =>
          t.jsx(
            "div",
            {
              style: {
                position: "absolute",
                left: n + d * (l + e(3.52)),
                top: i(5.78),
                width: l,
                height: e(24),
                borderRadius: 2.4,
                border: `0.5px solid ${o(0.13)}`,
                background: o(0.03),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              children: t.jsx("span", {
                style: { ...c, position: "static", fontSize: 5.5, textTransform: "none", color: o(0.5) },
                children: r,
              }),
            },
            r,
          ),
        ),
        t.jsx("span", { style: v(s.x, i(35.06), s.w, 0.08, 0.5) }),
        t.jsx("div", {
          style: { position: "absolute", inset: 0, animation: ut("woTabs") },
          children: t.jsxs("div", {
            style: {
              position: "absolute",
              left: n,
              top: i(35.56),
              width: a,
              height: e(28),
              borderRadius: 2.4,
              overflow: "hidden",
              display: "flex",
              boxShadow: `inset 0 0 0 0.5px ${o(0.13)}`,
            },
            children: [
              t.jsx("span", {
                style: {
                  display: "flex",
                  width: h,
                  height: "100%",
                  background: "rgb(var(--buy-rgb))",
                  alignItems: "center",
                  justifyContent: "center",
                },
                children: t.jsx("span", {
                  style: {
                    ...c,
                    position: "static",
                    fontSize: 5.5,
                    fontWeight: 585,
                    textTransform: "none",
                    color: "var(--showcase-on-buy)",
                  },
                  children: "Buy / Long",
                }),
              }),
              t.jsx("span", {
                style: {
                  display: "flex",
                  width: h,
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                },
                children: t.jsx("span", {
                  style: { ...c, position: "static", fontSize: 5.5, textTransform: "none", color: o(0.42) },
                  children: "Sell / Short",
                }),
              }),
            ],
          }),
        }),
        ["Market", "Limit"].map((r, d) =>
          t.jsx(
            "div",
            {
              style: {
                position: "absolute",
                left: n + d * e(46),
                top: i(74.1),
                width: e(42),
                height: e(21.04),
                borderRadius: 2.4,
                background: d === 0 ? o(0.09) : void 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              children: t.jsx("span", {
                style: {
                  ...c,
                  position: "static",
                  fontSize: 5.5,
                  textTransform: "none",
                  color: o(d === 0 ? 0.66 : 0.34),
                },
                children: r,
              }),
            },
            r,
          ),
        ),
        t.jsxs("div", {
          style: {
            position: "absolute",
            left: n + a - e(70),
            top: i(72.36),
            width: e(70),
            height: e(24.56),
            borderRadius: 1.8,
            border: `0.5px solid ${o(0.15)}`,
            background: o(0.02),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
          },
          children: [
            t.jsx("span", {
              style: { ...c, position: "static", fontSize: 5.5, textTransform: "none", color: o(0.55) },
              children: "Advanced",
            }),
            t.jsx("svg", {
              width: 6,
              height: 4,
              viewBox: "0 0 8 5",
              fill: "none",
              style: { display: "block" },
              children: t.jsx("path", {
                d: "M1 1 L4 4 L7 1",
                stroke: o(0.45),
                strokeWidth: 1.2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            }),
          ],
        }),
        t.jsx("span", { style: v(s.x, i(100.44), s.w, 0.07, 0.5) }),
        t.jsxs("div", {
          style: { position: "absolute", inset: 0, animation: ut("woA") },
          children: [
            [0, 1].map((r) =>
              t.jsxs(
                m.Fragment,
                {
                  children: [
                    t.jsx("span", { style: v(n, i(109.74 + r * 19.28), e([76, 46][r]), 0.1, 3) }),
                    t.jsx("span", {
                      style: {
                        ...v(0, i(109.74 + r * 19.28), e([44, 34][r]), 0.2, 3),
                        left: void 0,
                        right: I.w - (n + a),
                      },
                    }),
                  ],
                },
                r,
              ),
            ),
            t.jsx("div", { style: { ...B(n, i(151.82), a, e(28.16), 0.1, 1.8), background: o(0.015) } }),
            t.jsx("span", { style: v(n + e(7.04), i(161), e(34), 0.22, 3) }),
            t.jsx("span", {
              style: { ...v(0, i(161), e(48), 0.34, 3), left: void 0, right: I.w - (n + a - e(30)) },
            }),
            t.jsx("span", {
              style: {
                ...c,
                left: void 0,
                right: I.w - (n + a - e(7.04)),
                top: i(162),
                fontSize: 5,
                color: o(0.4),
              },
              children: "ETH",
            }),
            t.jsx("span", {
              style: {
                position: "absolute",
                left: n,
                top: i(203),
                width: a,
                height: e(10),
                borderRadius: e(5),
                background: o(0.1),
              },
            }),
            t.jsx("span", {
              style: {
                position: "absolute",
                left: n + e(2),
                top: i(205),
                width: a * 0.42,
                height: e(6),
                borderRadius: e(3),
                background: "rgba(var(--buy-rgb), 0.28)",
              },
            }),
            [0, 1, 2, 3, 4].map((r) =>
              t.jsx(
                "span",
                {
                  style: {
                    position: "absolute",
                    left: n + e(5.5) + (r * (a - e(11))) / 4 - e(3),
                    top: i(205),
                    width: e(6),
                    height: e(6),
                    borderRadius: "50%",
                    background: o(0.15),
                  },
                },
                r,
              ),
            ),
            t.jsx("span", {
              style: {
                position: "absolute",
                left: n + a * 0.42 - e(4),
                top: i(198),
                width: e(8),
                height: e(20),
                borderRadius: e(4),
                background: "rgb(var(--buy-rgb))",
              },
            }),
            [0, 1].map((r) =>
              t.jsxs(
                m.Fragment,
                {
                  children: [
                    t.jsx("span", {
                      style: {
                        position: "absolute",
                        left: n + r * e(146),
                        top: i(245),
                        width: e(14),
                        height: e(14),
                        borderRadius: 1,
                        border: `0.5px solid ${o(0.22)}`,
                      },
                    }),
                    t.jsx("span", { style: v(n + r * e(146) + e(21), i(250), e([30, 52][r]), 0.14, 3) }),
                  ],
                },
                r,
              ),
            ),
            t.jsx("span", { style: v(n, i(272), e(52), 0.16, 3) }),
            t.jsx("svg", {
              style: { position: "absolute", left: n + a - e(11), top: i(273) },
              width: 6,
              height: 4,
              viewBox: "0 0 8 5",
              fill: "none",
              children: t.jsx("path", {
                d: "M1 1 L4 4 L7 1",
                stroke: o(0.34),
                strokeWidth: 1.2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }),
            }),
            t.jsx("span", { style: v(s.x, i(290), s.w, 0.06, 0.5) }),
            Lt("PLACE BUY MARKET", 295),
            Ot(8, 0, 341),
          ],
        }),
        t.jsxs("div", {
          style: { position: "absolute", inset: 0, opacity: 0, animation: ut("woB") },
          children: [
            t.jsx("span", {
              style: { ...c, left: n, top: i(112), fontSize: 5.5, color: L(0.85) },
              children: "RUNNING TIME",
            }),
            [0, 1].map((r) =>
              t.jsxs(
                m.Fragment,
                {
                  children: [
                    t.jsx("div", {
                      style: {
                        ...B(n + r * (a / 2), i(126), a / 2, e(28.16), 0.1, 1.8),
                        background: o(0.015),
                      },
                    }),
                    t.jsx("span", { style: v(n + r * (a / 2) + e(7.04), i(135), e(26), 0.2, 3) }),
                  ],
                },
                r,
              ),
            ),
            t.jsx("span", {
              style: { ...c, left: n, top: i(166), fontSize: 5.5, color: o(0.3) },
              children: "EXECUTION",
            }),
            t.jsx("div", {
              style: {
                position: "absolute",
                left: n,
                top: i(178),
                width: a,
                height: e(24.6),
                borderRadius: 2.4,
                border: `0.5px solid ${o(0.15)}`,
                display: "flex",
                padding: e(1.76),
                gap: 0,
              },
              children: ["Passive", "Normal", "Aggressive"].map((r, d) =>
                t.jsx(
                  "span",
                  {
                    style: {
                      display: "flex",
                      flex: 1,
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 1.8,
                      background: d === 1 ? o(0.88) : void 0,
                    },
                    children: t.jsx("span", {
                      style: {
                        ...c,
                        position: "static",
                        fontSize: 5,
                        textTransform: "none",
                        color: d === 1 ? "var(--showcase-sheet)" : o(0.38),
                      },
                      children: r,
                    }),
                  },
                  r,
                ),
              ),
            }),
            [0, 1].map((r) =>
              t.jsxs(
                m.Fragment,
                {
                  children: [
                    t.jsx("span", { style: v(n, i(214 + r * 46), e([64, 52][r]), 0.14, 3) }),
                    [0, 1, 2, 3].map((d) =>
                      t.jsx(
                        "span",
                        {
                          style: {
                            position: "absolute",
                            left: n + a - (4 - d) * e(21),
                            top: i(210 + r * 46),
                            width: e(18),
                            height: e(11),
                            borderRadius: 1.5,
                            border: `0.5px solid ${o(d === 1 && r === 0 ? 0.4 : 0.13)}`,
                          },
                        },
                        d,
                      ),
                    ),
                    t.jsx("div", {
                      style: { ...B(n, i(226 + r * 46), a, e(28.16), 0.1, 1.8), background: o(0.015) },
                    }),
                    t.jsx("span", { style: v(n + e(7.04), i(235 + r * 46), e(30), 0.2, 3) }),
                  ],
                },
                r,
              ),
            ),
            Lt("START ADVANCED TWAP", 305),
            Ot(7, 3, 341),
          ],
        }),
        t.jsxs("div", {
          style: { position: "absolute", inset: 0, opacity: 0, animation: ut("woC") },
          children: [
            t.jsx("span", { style: v(n, i(109.74), e(76), 0.1, 3) }),
            t.jsx("span", {
              style: { ...v(0, i(109.74), e(34), 0.2, 3), left: void 0, right: I.w - (n + a) },
            }),
            t.jsx("div", { style: { ...B(n, i(132), a, e(28.16), 0.1, 1.8), background: o(0.015) } }),
            t.jsx("span", { style: v(n + e(7.04), i(141), e(34), 0.22, 3) }),
            t.jsx("span", {
              style: {
                ...c,
                left: void 0,
                right: I.w - (n + a - e(7.04)),
                top: i(142),
                fontSize: 5,
                color: o(0.4),
              },
              children: "USDC",
            }),
            [
              ["LONGS", "var(--buy-rgb)", ["ETH", "SOL"]],
              ["SHORTS", "var(--sell-rgb)", ["BTC"]],
            ].map(([r, d, b], p) =>
              t.jsxs(
                m.Fragment,
                {
                  children: [
                    t.jsx("div", {
                      style: {
                        position: "absolute",
                        left: n,
                        top: i(172 + p * 110),
                        width: a,
                        height: e(24.64 + b.length * 32 + 8),
                        borderRadius: 3,
                        border: `0.5px solid rgba(${d}, 0.3)`,
                        background: `rgba(${d}, 0.04)`,
                      },
                    }),
                    t.jsx("span", {
                      style: {
                        ...c,
                        left: n + e(7.04),
                        top: i(180 + p * 110),
                        fontSize: 5.5,
                        color: `rgba(${d}, 0.85)`,
                      },
                      children: r,
                    }),
                    b.map((g, u) =>
                      t.jsxs(
                        m.Fragment,
                        {
                          children: [
                            t.jsx("span", {
                              style: {
                                ...c,
                                left: n + e(7.04),
                                top: i(204 + p * 110 + u * 32),
                                fontSize: 5.5,
                                textTransform: "none",
                                color: o(0.55),
                              },
                              children: g,
                            }),
                            t.jsx("span", {
                              style: {
                                ...Z,
                                left: void 0,
                                right: I.w - (n + a - e(7.04)),
                                top: i(203 + p * 110 + u * 32),
                                fontSize: 6,
                                color: o(0.45),
                              },
                              children: p ? "50%" : "25%",
                            }),
                          ],
                        },
                        g,
                      ),
                    ),
                  ],
                },
                r,
              ),
            ),
            t.jsxs("div", {
              style: {
                position: "absolute",
                left: n,
                top: i(372),
                width: a,
                height: e(7.04),
                borderRadius: 1,
                overflow: "hidden",
                display: "flex",
              },
              children: [
                t.jsx("span", {
                  style: {
                    display: "block",
                    width: "50%",
                    height: "100%",
                    background: "rgba(var(--buy-rgb), 0.6)",
                  },
                }),
                t.jsx("span", {
                  style: {
                    display: "block",
                    width: "50%",
                    height: "100%",
                    background: "rgba(var(--sell-rgb), 0.6)",
                  },
                }),
              ],
            }),
            Lt("PLACE ATOMIC ORDER", 400),
            Ot(4, 6, 446),
          ],
        }),
        t.jsxs("div", {
          style: {
            position: "absolute",
            left: n + a - e(160),
            top: i(100),
            width: e(160),
            height: e(128),
            transformOrigin: "100% 0%",
            opacity: 0,
            transform: "scale(0.96)",
            animation: ut("woMenu"),
            zIndex: 4,
          },
          children: [
            t.jsx("div", {
              style: {
                position: "absolute",
                inset: 0,
                borderRadius: 2.4,
                border: `0.5px solid ${o(0.18)}`,
                background: vt,
                boxShadow: "0 14px 34px rgba(0, 0, 0, 0.5)",
              },
            }),
            t.jsx("span", {
              style: {
                position: "absolute",
                left: e(4),
                width: e(152),
                height: e(24.6),
                borderRadius: 1.8,
                background: o(0.07),
                opacity: 0,
                top: e(4 + 2 * 24.6),
                animation: ut("woHov"),
              },
            }),
            Xe.map((r, d) =>
              t.jsx(
                "span",
                {
                  style: {
                    ...c,
                    left: e(11),
                    top: e(11 + d * 24.6),
                    fontSize: 5.5,
                    color: o(d === 2 ? 0.62 : 0.4),
                  },
                  children: r,
                },
                r,
              ),
            ),
          ],
        }),
        t.jsx(Wt, { x: s.x + s.w + 18, y1: s.y, y2: s.y + s.h, num: "608" }),
        t.jsx(Mt, { x1: s.x, x2: s.x + s.w, y: s.y + s.h + 16, num: "304" }),
        t.jsx(At, {
          pts: [
            [n + a, i(112)],
            [560, i(112)],
            [560, i(84)],
          ],
          label: "5 ADVANCED ORDER TYPES",
          labelAt: [568, i(74)],
        }),
        t.jsx(zt, { park: [660, 380], move: "woCur", press: "woPress", dip: "woDip", dur: 6 }),
      ],
    });
  },
  $ = { x: 150, y: 78, w: 500, h: 281 },
  qe = I.w - ($.x + $.w),
  ThemeDesk = ({ light: e }) => {
    const s = e ? "#f4f4f5" : "#0c0c10",
      n = e ? "#ffffff" : "#16161a",
      a = e ? "rgba(25,27,29,0.12)" : "rgba(255,255,255,0.1)",
      i = e ? "#191b1d" : "oklch(0.964 0 0)",
      l = e ? "rgba(25,27,29,0.45)" : "oklch(0.964 0 0 / 0.45)";
    return t.jsxs("div", {
      style: {
        position: "absolute",
        inset: 0,
        background: s,
        overflow: "hidden",
        fontFamily: "var(--font-mono)",
      },
      children: [
        t.jsx("div", {
          style: {
            height: 22,
            borderBottom: `0.5px solid ${a}`,
            background: n,
            display: "flex",
            alignItems: "center",
            padding: "0 8px",
            gap: 5,
          },
          children: [48, 36, 44, 40, 28].map((h, r) =>
            t.jsx(
              "span",
              {
                style: {
                  display: "block",
                  width: h,
                  height: 5,
                  borderRadius: 1,
                  background: r === 0 ? i : l,
                  opacity: r === 0 ? 0.85 : 0.35,
                },
              },
              r,
            ),
          ),
        }),
        t.jsxs("div", {
          style: { display: "flex", height: $.h - 22 },
          children: [
            t.jsxs("div", {
              style: { flex: 1.6, borderRight: `0.5px solid ${a}`, position: "relative", background: s },
              children: [
                t.jsx("div", {
                  style: { height: 18, borderBottom: `0.5px solid ${a}`, display: "flex", alignItems: "center", gap: 6, padding: "0 6px" },
                  children: [22, 18, 16, 20].map((h, r) =>
                    t.jsx("span", { style: { width: h, height: 4, borderRadius: 1, background: l } }, r),
                  ),
                }),
                t.jsx("svg", {
                  viewBox: "0 0 280 160",
                  preserveAspectRatio: "none",
                  style: { position: "absolute", left: 8, right: 8, top: 28, bottom: 18, width: "auto", height: "auto" },
                  children: t.jsx("path", {
                    d: "M0 110 L28 96 L52 104 L80 78 L110 88 L140 54 L168 70 L198 40 L228 58 L260 32 L280 44",
                    fill: "none",
                    stroke: "rgb(60,255,178)",
                    strokeWidth: 1.4,
                    opacity: 0.85,
                  }),
                }),
              ],
            }),
            t.jsx("div", {
              style: { width: 92, borderRight: `0.5px solid ${a}`, background: n, padding: "8px 6px" },
              children: [0, 1, 2, 3, 4, 5].map((h) =>
                t.jsx(
                  "span",
                  {
                    style: {
                      display: "block",
                      height: 7,
                      marginBottom: 5,
                      borderRadius: 1,
                      background: h < 3 ? "rgba(255,0,64,0.45)" : "rgba(60,255,178,0.4)",
                      width: `${70 - h * 6}%`,
                    },
                  },
                  h,
                ),
              ),
            }),
            t.jsxs("div", { style: { width: 108, background: n, padding: 8 }, children: [
              t.jsxs("div", { style: { display: "flex", height: 16, borderRadius: 3, overflow: "hidden", marginBottom: 8 }, children: [
                t.jsx("span", { style: { flex: 1, background: "rgb(60,255,178)" } }),
                t.jsx("span", { style: { flex: 1, background: a } }),
              ] }),
              t.jsx("span", { style: { display: "block", height: 6, width: "70%", background: l, borderRadius: 1, marginBottom: 6 } }),
              t.jsx("span", { style: { display: "block", height: 6, width: "48%", background: l, borderRadius: 1, marginBottom: 14 } }),
              t.jsx("span", { style: { display: "block", height: 18, borderRadius: 4, background: "rgb(60,255,178)" } }),
            ] }),
          ],
        }),
      ],
    });
  },
  ThemePhoto = ({ src: e, light: s }) => {
    const [failed, setFailed] = m.useState(!1)
    return t.jsxs("div", {
      style: {
        position: "absolute",
        inset: 0,
        background: s ? "#ecece8" : "#0c0c10",
      },
      children: [
        failed
          ? t.jsx(ThemeDesk, { light: s })
          : t.jsx("img", {
              src: e,
              alt: "",
              draggable: !1,
              style: {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center top",
                display: "block",
                filter: s ? "invert(1) hue-rotate(180deg) saturate(0.55) brightness(1.18)" : undefined,
              },
              onError: () => setFailed(!0),
            }),
      ],
    })
  },
  Ze = () =>
    t.jsxs(ft, {
      children: [
        t.jsxs("div", {
          style: {
            position: "absolute",
            left: $.x,
            top: $.y,
            width: $.w,
            height: $.h,
            borderRadius: 4,
            overflow: "hidden",
          },
          children: [
            t.jsx(ThemePhoto, { src: "/showcase/theme-dark.png", light: !1 }),
            t.jsx("div", {
              className: "absolute inset-0",
              style: {
                clipPath: "polygon(78% 0%, 100% 0%, 100% 100%, 64% 100%)",
                animation: "wtLight 6s ease-in-out infinite",
              },
              children: t.jsx(ThemePhoto, { src: "/showcase/theme-dark.png", light: !0 }),
            }),
            t.jsx("div", {
              style: {
                position: "absolute",
                top: -20,
                bottom: -20,
                left: "55%",
                width: 26,
                marginLeft: -13,
                background: `linear-gradient(90deg, transparent, ${o(0.14)}, transparent)`,
                transform: "rotate(14deg)",
                mixBlendMode: "difference",
                animation: "wtSeam 6s ease-in-out infinite",
              },
            }),
            t.jsx("div", {
              style: {
                position: "absolute",
                top: -20,
                bottom: -20,
                left: "55%",
                width: 1,
                marginLeft: -0.5,
                background: o(0.6),
                transform: "rotate(14deg)",
                mixBlendMode: "difference",
                animation: "wtSeam 6s ease-in-out infinite",
              },
            }),
          ],
        }),
        t.jsx("div", {
          style: {
            position: "absolute",
            left: $.x,
            top: $.y,
            width: $.w,
            height: $.h,
            borderRadius: 4,
            border: `0.5px solid ${o(0.3)}`,
            mixBlendMode: "difference",
            pointerEvents: "none",
          },
        }),
        t.jsx("span", {
          style: { ...c, left: "50%", top: 55.5, transform: "translateX(-50%)", color: o(0.55) },
          children: "SWITCH THEMES",
        }),
        t.jsx("span", { style: { ...c, left: $.x, top: $.y + $.h + 14, color: o(0.45) }, children: "DARK" }),
        t.jsx("span", {
          style: { ...c, right: qe, left: void 0, top: $.y + $.h + 14, color: o(0.45) },
          children: "LIGHT",
        }),
        t.jsx(Mt, { x1: $.x, x2: $.x + $.w, y: $.y + $.h + 34, num: "1440" }),
      ],
    }),
rt = [
    {
      id: "intro",
      labelKey: "launch_showcase_intro_label",
      titleKey: "launch_showcase_intro_title",
      bodyKey: "launch_showcase_intro_body",
      render: Te,
      loopMs: 6e3,
    },
    {
      id: "themes",
      labelKey: "launch_showcase_themes_label",
      titleKey: "launch_showcase_themes_title",
      bodyKey: "launch_showcase_themes_body",
      render: Ze,
      loopMs: 6e3,
    },
    {
      id: "markets",
      labelKey: "launch_showcase_markets_label",
      titleKey: "launch_showcase_markets_title",
      bodyKey: "launch_showcase_markets_body",
      render: Ye,
      loopMs: 6e3,
    },
    {
      id: "accounts",
      labelKey: "launch_showcase_accounts_label",
      titleKey: "launch_showcase_accounts_title",
      bodyKey: "launch_showcase_accounts_body",
      render: Ae,
      loopMs: 6e3,
    },
    {
      id: "layout",
      labelKey: "launch_showcase_layout_label",
      titleKey: "launch_showcase_layout_title",
      bodyKey: "launch_showcase_layout_body",
      render: Ue,
      loopMs: 1e4,
    },
    {
      id: "orders",
      labelKey: "launch_showcase_orders_label",
      titleKey: "launch_showcase_orders_title",
      bodyKey: "launch_showcase_orders_body",
      render: Ve,
      loopMs: 6e3,
    },
  ],
  Je = ({ frame: e, paused: s }) => {
    const n = m.useRef(null),
      [a, i] = m.useState(1);
    m.useLayoutEffect(() => {
      const h = n.current;
      if (!h) return;
      const measure = () => {
        const w = h.clientWidth;
        if (w > 0) i(w / I.w);
      };
      measure();
      const r = new ResizeObserver(measure);
      return (r.observe(h), () => r.disconnect());
    }, [e]);
    const l = e.render;
    return t.jsx("div", {
      ref: n,
      "data-wire-paused": s || void 0,
      style: {
        position: "relative",
        width: "100%",
        aspectRatio: `${I.w} / ${I.h}`,
        overflow: "hidden",
        background: dt,
      },
      children: t.jsx("div", {
        "aria-hidden": !0,
        style: {
          position: "absolute",
          left: 0,
          top: 0,
          width: I.w,
          height: I.h,
          transform: `scale(${Math.max(a, 0.01)})`,
          transformOrigin: "0 0",
          pointerEvents: "none",
          contain: "layout paint",
        },
        children: t.jsx(l, { paused: false }),
      }),
    });
  },
  Qe = [0.22, 1, 0.36, 1],
  ts = [0.16, 1, 0.3, 1],
  es =
    "relative shrink-0 cursor-pointer rounded-pill px-2 pt-1 pb-1.5 uppercase transition-colors outline-none",
  ss =
    "relative h-1.5 cursor-pointer overflow-hidden rounded-pill transition-all duration-300 outline-none before:absolute before:-inset-2 before:content-['']";

export const SHOWCASE_STEPS = rt
export const CHAPTER_BTN_CLASS = es
export const DOT_BTN_CLASS = ss
export const CHAPTER_EASE = Qe
export const FRAME_EASE = ts
export const MONO_CASE = be

export function ShowcaseFrame({ frame, paused }) {
  return t.jsx(Je, { frame, paused })
}
